var Dt = Object.defineProperty;
var It = (e, t, n) => t in e ? Dt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var O = (e, t, n) => (It(e, typeof t != "symbol" ? t + "" : t, n), n);
import { proxy as Ce } from "valtio/vanilla";
const mt = "http://localhost:8810", ut = "fastlocal.com", jt = ["localhost", "fastlocal.com"];
function J(e) {
  if (e === null)
    return null;
  if (typeof e == "string") {
    const [t, n] = e.split(" ");
    return /* @__PURE__ */ new Date(`${t}T${n}Z`);
  }
  return e;
}
const W = (e) => {
  e && (e.updated = J(e.updated), e.created = J(e.created));
}, gt = typeof window < "u" ? window.atob : (e) => Buffer.from(e, "base64").toString(), Nt = (e) => {
  try {
    const t = Date.now(), n = e.split(".").at(1) ?? "", { expires: a } = JSON.parse(gt(n));
    return !a || t >= a * 1e3;
  } catch (t) {
    return console.error(
      `[Validation Error] - Parsing auth token: ${t == null ? void 0 : t.message}`,
      new Error().stack
    ), !0;
  }
};
var Re = /* @__PURE__ */ ((e) => (e.Activity = "activity", e.Multiplayer = "multiplayer", e))(Re || {}), le = /* @__PURE__ */ ((e) => (e.DENIED = "denied", e.PONG = "pong", e.OK = "ok", e.READY = "ready", e.ACTIVITY = "activity", e.ACTIVITY_CURRENT = "activity_current", e.MULTIPLAYER = "multiplayer", e))(le || {}), he = /* @__PURE__ */ ((e) => (e.PING = "ping", e.ACTIVITY = "activity", e.CLOSE = "close", e))(he || {});
const de = "[Fast.io-WebSockets]", Ct = [
  le.DENIED,
  le.READY,
  le.PONG,
  le.OK
], yt = 90 * 1e3, Le = 30 * 1e3, Rt = {
  reconnectInterval: 10 * 1e3,
  maxReconnectAttempts: 20,
  autoReconnect: !0
}, Et = 3 * 1e3;
class Ot {
  constructor(t, n) {
    O(this, "url");
    O(this, "options");
    O(this, "socket", null);
    O(this, "pingInterval", null);
    O(this, "reconnectCount", 0);
    O(this, "reconnectTimeout", null);
    O(this, "manualClose", !1);
    O(this, "authToken", null);
    O(this, "readyMessageReceived", !1);
    this.url = t, this.options = {
      ...Rt,
      ...n
    };
  }
  async connect() {
    if (this.isOpen)
      return;
    this.readyMessageReceived = !1;
    const t = await this.fetchOrGetAuthToken();
    if (!t) {
      this.attemptReconnectWithDelay({ longWait: !0 });
      return;
    }
    const n = this.url.replace("{{token}}", t);
    this.socket = new WebSocket(n), this.manualClose = !1, this.socket.onopen = this.handleOpen.bind(this), this.socket.onmessage = this.handleMessage.bind(this), this.socket.onerror = this.handleError.bind(this), this.socket.onclose = this.handleClose.bind(this);
  }
  handleOpen(t) {
    var n, a;
    this.reconnectCount = 0, this.resetPingInterval(), (a = (n = this.options).onOpen) == null || a.call(n, t), this.setReadyMessageTimeoutCheck();
  }
  setReadyMessageTimeoutCheck() {
    setTimeout(() => {
      this.readyMessageReceived || this.handleError(new Event("Ready message not received"));
    }, Et);
  }
  async handleMessage(t) {
    var n, a;
    if (this.options.onMessage)
      try {
        const h = typeof t.data == "string" ? t.data : t.data.toString(), D = JSON.parse(h);
        switch (D.response) {
          case le.READY:
            this.handleReadyResponse();
            break;
          case le.DENIED:
            this.handleDeniedResponse();
            break;
          default:
            Ct.includes(D.response) || this.options.onMessage(D);
        }
      } catch (h) {
        h instanceof SyntaxError ? console.error("Failed to parse WebSocket message:", h) : console.error("Error handling WebSocket message:", h), (a = (n = this.options).onErrorMessage) == null || a.call(n, h);
      }
  }
  handleError(t) {
    var n, a;
    console.error(
      `${de} Connection to ${this.url} failed - reason ${JSON.stringify(t)}.`
    ), (a = (n = this.options).onError) == null || a.call(n, t), this.close(!1);
  }
  handleClose(t) {
    var n, a;
    this.clearPingInterval(), (a = (n = this.options).onClose) == null || a.call(n, t, this.manualClose), this.attemptReconnectWithDelay();
  }
  send(t, n = !0) {
    var a;
    if (this.socket && this.isOpen) {
      const h = n ? JSON.stringify({ data: t }) : t;
      this.socket.send(h);
    } else
      console.error(
        `${de} Failed on send ${this.url} is not open, state: ${(a = this.socket) == null ? void 0 : a.readyState}.`
      );
  }
  close(t = !0, n, a) {
    var h;
    try {
      this.manualClose = t, this.clearPingInterval(), this.clearReconnectTimeout(), this.socket && this.isOpen && this.sendClose(), (h = this.socket) == null || h.close(n, a);
    } catch (D) {
      console.error(
        `${de} An error occurred while closing the WebSocket connection`,
        D
      );
    }
  }
  get readyState() {
    var t;
    return ((t = this.socket) == null ? void 0 : t.readyState) || WebSocket.CLOSED;
  }
  get isOpen() {
    var t;
    return ((t = this.socket) == null ? void 0 : t.readyState) === WebSocket.OPEN;
  }
  async handleDeniedResponse() {
    this.authToken = null;
    const t = await this.fetchNewToken(!0);
    t && (this.authToken = t, this.attemptReconnectWithDelay());
  }
  calculateReconnectionDelay(t, n) {
    return t ? Le : Math.min(
      n * 2 ** (this.reconnectCount - 1),
      Le
    );
  }
  attemptReconnectWithDelay({
    longWait: t = !1
  } = {}) {
    if (this.manualClose)
      return;
    const n = this.options.maxReconnectAttempts ?? 0;
    if (this.reconnectCount < n) {
      this.reconnectCount++;
      const a = this.options.reconnectInterval ?? 0, h = this.calculateReconnectionDelay(
        t,
        a
      );
      console.debug(
        `${de} Attempting to reconnect in ${h}ms ${t ? "(long wait)" : ""}`
      ), this.reconnectTimeout = setTimeout(
        () => this.connect(),
        h
      );
    } else
      console.debug(`${de} Max reconnection attempts reached`);
  }
  resetPingInterval() {
    this.clearPingInterval(), this.pingInterval = setInterval(() => {
      this.sendPing();
    }, yt);
  }
  sendClose() {
    this.send(he.CLOSE, !1);
  }
  sendPing() {
    this.send(he.PING, !1);
  }
  sendActivity() {
    this.send(he.ACTIVITY, !1);
  }
  clearPingInterval() {
    this.pingInterval && (clearInterval(this.pingInterval), this.pingInterval = null);
  }
  clearReconnectTimeout() {
    this.reconnectTimeout && (clearTimeout(this.reconnectTimeout), this.reconnectTimeout = null);
  }
  async fetchOrGetAuthToken() {
    return this.authToken && !Nt(this.authToken) ? this.authToken : this.fetchNewToken();
  }
  async fetchNewToken(t = !1) {
    try {
      const n = await this.options.fetchAuth(t);
      if (n)
        return this.authToken = n, n;
    } catch (n) {
      console.error(`${de} Error fetching new token:`, n);
    }
  }
  handleReadyResponse() {
    var t, n;
    this.readyMessageReceived = !0, (n = (t = this.options).onReady) == null || n.call(t), this.options.webSocketCategory === Re.Activity ? this.sendActivity() : (this.options.webSocketCategory, Re.Multiplayer);
  }
}
const Kt = "ws://localhost:8811", Ge = ({
  path: e,
  options: t
}) => {
  const n = bt(e), a = new Ot(n, t);
  return a.connect(), a;
}, bt = (e) => {
  let t = typeof window < "u" ? window.location.origin.replace(/^http/, "ws") : "";
  return jt.some((n) => t.includes(n)) && (t = Kt), `${t}/api/websocket/${e}?{{token}}`;
}, Ve = {
  ACTIVITY: () => "",
  MULTIPLAYER: () => "/multiplayer"
}, rt = (e) => Ge({
  path: Ve.ACTIVITY(),
  options: e
}), Xt = (e) => Ge({
  path: Ve.MULTIPLAYER(),
  options: e
}), rl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  activityWebSocket: rt,
  multiplayerWebSocket: Xt
}, Symbol.toStringTag, { value: "Module" }));
var Oe = /* @__PURE__ */ ((e) => (e[e.ApiUserTokenBasicInvalid = 10001] = "ApiUserTokenBasicInvalid", e[e.RequestTypeInvalid = 10003] = "RequestTypeInvalid", e[e.ApiUserTokenUserInvalid = 10004] = "ApiUserTokenUserInvalid", e[e.ApiUserTokenPassInvalid = 10005] = "ApiUserTokenPassInvalid", e[e.UserNotFound = 10006] = "UserNotFound", e[e.PassNotSet = 10007] = "PassNotSet", e[e.CredentialsInvalid = 10008] = "CredentialsInvalid", e[e.JwtCreation = 10009] = "JwtCreation", e[e.Disabled = 10010] = "Disabled", e[e.AuthorizationInvalid = 10011] = "AuthorizationInvalid", e[e.InitTokenObject = 10012] = "InitTokenObject", e[e.TokenUserSet = 10014] = "TokenUserSet", e[e.TokenTooManyKeys = 10015] = "TokenTooManyKeys", e[e.TokenMemoInvalid = 10016] = "TokenMemoInvalid", e[e.TokenCreate = 10017] = "TokenCreate", e[e.TokenStore = 10018] = "TokenStore", e[e.TokenInvalid = 10019] = "TokenInvalid", e[e.TokenMissing = 10020] = "TokenMissing", e[e.TokenDelete = 10021] = "TokenDelete", e[e.EmailInvalid = 10022] = "EmailInvalid", e[e.UserMiscompare = 10023] = "UserMiscompare", e[e.UserNotLoggedIn = 10024] = "UserNotLoggedIn", e[e.UserEmailInvalid = 10025] = "UserEmailInvalid", e[e.UserPassInvalid = 10026] = "UserPassInvalid", e[e.UserFirstNameInvalid = 10027] = "UserFirstNameInvalid", e[e.UserPhoneNumberInvalid = 10029] = "UserPhoneNumberInvalid", e[e.UserNothingToUpdate = 10030] = "UserNothingToUpdate", e[e.UserPassEncodeFailure = 10031] = "UserPassEncodeFailure", e[e.UserCommitChanges = 10032] = "UserCommitChanges", e[e.UserCodeInvalid = 10033] = "UserCodeInvalid", e[e.UserCodeCreate = 10035] = "UserCodeCreate", e[e.UserEmailAlreadyVerified = 10037] = "UserEmailAlreadyVerified", e[e.StorageProviderGenericInit = 10038] = "StorageProviderGenericInit", e[e.SsoProviderInvalid = 10041] = "SsoProviderInvalid", e[e.ProviderInvalid = 10043] = "ProviderInvalid", e[e.ProviderDeleteFailed = 10044] = "ProviderDeleteFailed", e[e.ServerConfigExists = 10045] = "ServerConfigExists", e[e.CdnNotReady = 10076] = "CdnNotReady", e[e.CdnProviderGenericInit = 10064] = "CdnProviderGenericInit", e[e.CdnGetProviderList = 10065] = "CdnGetProviderList", e[e.ServerInit = 10069] = "ServerInit", e[e.ServerUseridSet = 10070] = "ServerUseridSet", e[e.DomainInvalidConfigName = 10071] = "DomainInvalidConfigName", e[e.DomainRestrictedServerName = 10072] = "DomainRestrictedServerName", e[e.DomainConfigNameInUse = 10073] = "DomainConfigNameInUse", e[e.ServerNotReady = 10074] = "ServerNotReady", e[e.ServerInvalidConfigValue = 10079] = "ServerInvalidConfigValue", e[e.ServerAnalyticsProfileInvalid = 10081] = "ServerAnalyticsProfileInvalid", e[e.ServerCdnProviderInvalid = 10082] = "ServerCdnProviderInvalid", e[e.ServerConfigFailure = 10083] = "ServerConfigFailure", e[e.ServerConfigStore = 10085] = "ServerConfigStore", e[e.ServerConfigMissing = 10086] = "ServerConfigMissing", e[e.ServerDeleteFailed = 10087] = "ServerDeleteFailed", e[e.ServerConfigInvalid = 10088] = "ServerConfigInvalid", e[e.ServerUserConfigsGet = 10089] = "ServerUserConfigsGet", e[e.ServerDeletedNoop = 10090] = "ServerDeletedNoop", e[e.ServerFolderExistsCreate = 10091] = "ServerFolderExistsCreate", e[e.ServerInitStorage = 10092] = "ServerInitStorage", e[e.ServerPathGet = 10096] = "ServerPathGet", e[e.StorageAuth = 10097] = "StorageAuth", e[e.StorageInvalidResult = 10098] = "StorageInvalidResult", e[e.ServerLockedNoop = 10099] = "ServerLockedNoop", e[e.ServerCdnDeliveryFailed = 10100] = "ServerCdnDeliveryFailed", e[e.ServerCdnDeliveryFailedInternal = 10101] = "ServerCdnDeliveryFailedInternal", e[e.EventIdInvalid = 10102] = "EventIdInvalid", e[e.AccountClosed = 10103] = "AccountClosed", e[e.AccountLocked = 10104] = "AccountLocked", e[e.AccountSuspended = 10105] = "AccountSuspended", e[e.AccountDmca = 10106] = "AccountDmca", e[e.LogInit = 10107] = "LogInit", e[e.LogStartInvalid = 10108] = "LogStartInvalid", e[e.LogEndInvalid = 10109] = "LogEndInvalid", e[e.LogIntervalFailed = 10110] = "LogIntervalFailed", e[e.LogMaxDaysOverflow = 10111] = "LogMaxDaysOverflow", e[e.LogConstMissing = 10112] = "LogConstMissing", e[e.LogFormatInvalid = 10113] = "LogFormatInvalid", e[e.StatsInitDatetime = 10114] = "StatsInitDatetime", e[e.StatsQueryFailed = 10115] = "StatsQueryFailed", e[e.StatsIntervalFailed = 10116] = "StatsIntervalFailed", e[e.StatsMaxDaysOverflow = 10117] = "StatsMaxDaysOverflow", e[e.StatsStartInvalid = 10118] = "StatsStartInvalid", e[e.StatsEndInvalid = 10119] = "StatsEndInvalid", e[e.EventGetNotFound = 10124] = "EventGetNotFound", e[e.EventFailedToAck = 10125] = "EventFailedToAck", e[e.FlushFailedToFlushAfterCreation = 10126] = "FlushFailedToFlushAfterCreation", e[e.FlushFailedToWebhookAfterCreation = 10136] = "FlushFailedToWebhookAfterCreation", e[e.FlushFailedBeforeDelete = 10146] = "FlushFailedBeforeDelete", e[e.ServerStorageSwitchAuthFailed = 10147] = "ServerStorageSwitchAuthFailed", e[e.ServerConfigOrigInvalid = 10148] = "ServerConfigOrigInvalid", e[e.FlushFailedAfterUpdate = 10149] = "FlushFailedAfterUpdate", e[e.ServerSwitchStorageFolderExistsCreate = 10151] = "ServerSwitchStorageFolderExistsCreate", e[e.ServerInvalidConfigExpires = 10160] = "ServerInvalidConfigExpires", e[e.StoreConfigStore = 10161] = "StoreConfigStore", e[e.ServerConfigErrorPath = 10162] = "ServerConfigErrorPath", e[e.UserPhoneCountryInvalid = 10163] = "UserPhoneCountryInvalid", e[e.UserChangeDisable2factorFirst = 10164] = "UserChangeDisable2factorFirst", e[e.UserPhoneFullInvalid = 10165] = "UserPhoneFullInvalid", e[e.TwoFactorAlreadyAdded = 10167] = "TwoFactorAlreadyAdded", e[e.TwoFactorNoPhoneAdded = 10168] = "TwoFactorNoPhoneAdded", e[e.TwoFactorRemovalFailed = 10169] = "TwoFactorRemovalFailed", e[e.TwoFactorVerificationNotEnabled = 10170] = "TwoFactorVerificationNotEnabled", e[e.TwoFactorVerifyUpdateFailed = 10171] = "TwoFactorVerifyUpdateFailed", e[e.TwoFactorNotEnabled = 10172] = "TwoFactorNotEnabled", e[e.TwoFactorInvalidToken = 10173] = "TwoFactorInvalidToken", e[e.TwoFactorTokenFailed = 10174] = "TwoFactorTokenFailed", e[e.AuthorizationScopeIncorrect = 10175] = "AuthorizationScopeIncorrect", e[e.BillingPlanInvalid = 10176] = "BillingPlanInvalid", e[e.BillingBillingInit = 10177] = "BillingBillingInit", e[e.BillingTokenInvalid = 10178] = "BillingTokenInvalid", e[e.SubscriptionExists = 10179] = "SubscriptionExists", e[e.SubscriptionCreateFailed = 10180] = "SubscriptionCreateFailed", e[e.SubscriptionStateUnknown = 10182] = "SubscriptionStateUnknown", e[e.SubscriptionUpdateFailed = 10183] = "SubscriptionUpdateFailed", e[e.SubscriptionCancelMissing = 10184] = "SubscriptionCancelMissing", e[e.SubscriptionCancelFailed = 10185] = "SubscriptionCancelFailed", e[e.SubscriptionResetFailed = 10186] = "SubscriptionResetFailed", e[e.SubscriptionDetailsFailed = 10188] = "SubscriptionDetailsFailed", e[e.SubscriptionUpdateEmailFailed = 10190] = "SubscriptionUpdateEmailFailed", e[e.SubscriptionAccountCloseCancelFailed = 10191] = "SubscriptionAccountCloseCancelFailed", e[e.WebhookSignatureInvalidStripe = 10192] = "WebhookSignatureInvalidStripe", e[e.WebhookSignatureInvalidStripeParts = 10193] = "WebhookSignatureInvalidStripeParts", e[e.WebhookSignatureInvalidStripeHmac = 10194] = "WebhookSignatureInvalidStripeHmac", e[e.WebhookEnqueueFailedStripe = 10195] = "WebhookEnqueueFailedStripe", e[e.SubscriptionOnlyTestModeAction = 10196] = "SubscriptionOnlyTestModeAction", e[e.PasswordCodeInvalid = 10197] = "PasswordCodeInvalid", e[e.PasswordCodeNotFoundOrExpired = 10198] = "PasswordCodeNotFoundOrExpired", e[e.PasswordCodeExpired = 10199] = "PasswordCodeExpired", e[e.PasswordCodeUserMismatch = 10200] = "PasswordCodeUserMismatch", e[e.PasswordCodeUserNotFound = 10201] = "PasswordCodeUserNotFound", e[e.PasswordDontMatch = 10202] = "PasswordDontMatch", e[e.PasswordEncryptionFailed = 10203] = "PasswordEncryptionFailed", e[e.PasswordCommitFailed = 10204] = "PasswordCommitFailed", e[e.PasswordGetJwtFailed = 10205] = "PasswordGetJwtFailed", e[e.PasswordAccountLockedNoChange = 10207] = "PasswordAccountLockedNoChange", e[e.BillingPlanFree = 10215] = "BillingPlanFree", e[e.ServerDisableAllFailed = 10217] = "ServerDisableAllFailed", e[e.AppStatusInit = 10220] = "AppStatusInit", e[e.AppStatusInvalidChecks = 10221] = "AppStatusInvalidChecks", e[e.AppStatusInvalidLastactive = 10225] = "AppStatusInvalidLastactive", e[e.SsoProviderUnknown = 10226] = "SsoProviderUnknown", e[e.SsoInvalidInput = 10230] = "SsoInvalidInput", e[e.ServerInvalidFilterMode = 10235] = "ServerInvalidFilterMode", e[e.ServerInvalidFilter = 10236] = "ServerInvalidFilter", e[e.ServerInvalidPassword = 10238] = "ServerInvalidPassword", e[e.ServerInvalidOption = 10240] = "ServerInvalidOption", e[e.ServerNoChangesFound = 10241] = "ServerNoChangesFound", e[e.DomainsGenericInit = 10244] = "DomainsGenericInit", e[e.DomainsProviderUseridSet = 10245] = "DomainsProviderUseridSet", e[e.DomainsNotReady = 10246] = "DomainsNotReady", e[e.DomainsProviderUserGet = 10247] = "DomainsProviderUserGet", e[e.DomainsProviderInvalid = 10249] = "DomainsProviderInvalid", e[e.DomainsGetProviderDetails = 10250] = "DomainsGetProviderDetails", e[e.AppsGenericInit = 10254] = "AppsGenericInit", e[e.Oauth2SsoDenied = 10260] = "Oauth2SsoDenied", e[e.AppsProviderInvalidName = 10267] = "AppsProviderInvalidName", e[e.AppsInvalidConfigValue = 10269] = "AppsInvalidConfigValue", e[e.AppsInvalidConfigType = 10270] = "AppsInvalidConfigType", e[e.DomainsProviderInit = 10286] = "DomainsProviderInit", e[e.DomainsConfigMissing = 10287] = "DomainsConfigMissing", e[e.DomainsConfigFailure = 10288] = "DomainsConfigFailure", e[e.DomainsConfigStore = 10289] = "DomainsConfigStore", e[e.DomainsDeleteFailed = 10290] = "DomainsDeleteFailed", e[e.DomainsUserConfigsGet = 10291] = "DomainsUserConfigsGet", e[e.DomainsProvidersGetList = 10292] = "DomainsProvidersGetList", e[e.DomainsBlacklistedName = 10294] = "DomainsBlacklistedName", e[e.DomainsInvalidName = 10295] = "DomainsInvalidName", e[e.DomainsConfigExists = 10296] = "DomainsConfigExists", e[e.DomainsProviderDnsMissing = 10297] = "DomainsProviderDnsMissing", e[e.DomainsRegistryCheckFailed = 10298] = "DomainsRegistryCheckFailed", e[e.DomainsUnregRequiresDns = 10299] = "DomainsUnregRequiresDns", e[e.DomainsProviderRegistryMissing = 10300] = "DomainsProviderRegistryMissing", e[e.DomainsRegAlready = 10301] = "DomainsRegAlready", e[e.DomainsAutorenewInvalid = 10302] = "DomainsAutorenewInvalid", e[e.DomainsRegisterFailed = 10303] = "DomainsRegisterFailed", e[e.DomainsOrphanedDomain = 10304] = "DomainsOrphanedDomain", e[e.DomainsDeleteRegRejected = 10305] = "DomainsDeleteRegRejected", e[e.DomainsZoneCreate = 10306] = "DomainsZoneCreate", e[e.DomainsZoneDelete = 10307] = "DomainsZoneDelete", e[e.DomainsZoneGet = 10308] = "DomainsZoneGet", e[e.DomainsZoneMissingNs = 10309] = "DomainsZoneMissingNs", e[e.DomainsNotPurchasable = 10310] = "DomainsNotPurchasable", e[e.DomainsZoneExists = 10311] = "DomainsZoneExists", e[e.DomainsProviderDisabled = 10312] = "DomainsProviderDisabled", e[e.DomainsConfigInvalid = 10313] = "DomainsConfigInvalid", e[e.BindingInvalidVanityName = 10314] = "BindingInvalidVanityName", e[e.BindingInvalidOriginName = 10315] = "BindingInvalidOriginName", e[e.BindingInvalidOriginDomain = 10316] = "BindingInvalidOriginDomain", e[e.BindingOriginVanityMatch = 10317] = "BindingOriginVanityMatch", e[e.BindingOriginVanityFqdn = 10318] = "BindingOriginVanityFqdn", e[e.BindingOriginOriginFqdn = 10319] = "BindingOriginOriginFqdn", e[e.BindingServerOriginUnusable = 10320] = "BindingServerOriginUnusable", e[e.BindingConfigFailure = 10321] = "BindingConfigFailure", e[e.BindingConfigStore = 10322] = "BindingConfigStore", e[e.BindingConfigExists = 10323] = "BindingConfigExists", e[e.DnsRecordCreate = 10324] = "DnsRecordCreate", e[e.BindingConfigMissing = 10325] = "BindingConfigMissing", e[e.BindingConfigInvalidType = 10326] = "BindingConfigInvalidType", e[e.DnsRecordDelete = 10328] = "DnsRecordDelete", e[e.DnsRecordExternalCreate = 10330] = "DnsRecordExternalCreate", e[e.BindingGetList = 10332] = "BindingGetList", e[e.BindingLookup = 10333] = "BindingLookup", e[e.BindingServerLoad = 10334] = "BindingServerLoad", e[e.BindingSslStatus = 10335] = "BindingSslStatus", e[e.DomainActivate = 10336] = "DomainActivate", e[e.ServerFlushConfig = 10337] = "ServerFlushConfig", e[e.DomainDnsNotInternal = 10338] = "DomainDnsNotInternal", e[e.DomainDnsNotSupported = 10339] = "DomainDnsNotSupported", e[e.DomainDnsFilterInvalidType = 10340] = "DomainDnsFilterInvalidType", e[e.DomainDnsFilterInvalidName = 10341] = "DomainDnsFilterInvalidName", e[e.DomainDnsInvalidType = 10342] = "DomainDnsInvalidType", e[e.DomainDnsInvalidName = 10343] = "DomainDnsInvalidName", e[e.DomainDnsInvalidContent = 10344] = "DomainDnsInvalidContent", e[e.DomainDnsInvalidTtl = 10345] = "DomainDnsInvalidTtl", e[e.DomainDnsInvalidPriority = 10346] = "DomainDnsInvalidPriority", e[e.DomainDnsPriorityNotSupported = 10347] = "DomainDnsPriorityNotSupported", e[e.DomainDnsRecordLocked = 10348] = "DomainDnsRecordLocked", e[e.DomainsPurchaseFailed = 10349] = "DomainsPurchaseFailed", e[e.StripeRefundFailed = 10350] = "StripeRefundFailed", e[e.UserFraudRisk = 10354] = "UserFraudRisk", e[e.BillingFeatureServerPasswords = 10356] = "BillingFeatureServerPasswords", e[e.BillingFeatureCustomErrors = 10358] = "BillingFeatureCustomErrors", e[e.BillingFeatureRawLogs = 10359] = "BillingFeatureRawLogs", e[e.BillingLimitsCustomDomains = 10361] = "BillingLimitsCustomDomains", e[e.BillingLimitsSslBindings = 10362] = "BillingLimitsSslBindings", e[e.BillingLimitsServers = 10363] = "BillingLimitsServers", e[e.DomainDnsQueueInsert = 10365] = "DomainDnsQueueInsert", e[e.DomainBindingInsert = 10367] = "DomainBindingInsert", e[e.EnhanceCalm = 10368] = "EnhanceCalm", e[e.ServerSwitchStorageInitFailed = 10370] = "ServerSwitchStorageInitFailed", e[e.ServerSwitchStorageSetFailed = 10371] = "ServerSwitchStorageSetFailed", e[e.ServerInvalidStorageBranch = 10372] = "ServerInvalidStorageBranch", e[e.ServerInvalidStorageRoot = 10374] = "ServerInvalidStorageRoot", e[e.StorageReposGet = 10377] = "StorageReposGet", e[e.StorageBranchesGet = 10379] = "StorageBranchesGet", e[e.StorageBranchNotSet = 10380] = "StorageBranchNotSet", e[e.StorageRepoNotSet = 10381] = "StorageRepoNotSet", e[e.UserInit = 10382] = "UserInit", e[e.StoreFailed = 10384] = "StoreFailed", e[e.DomainConfigStore = 10385] = "DomainConfigStore", e[e.DomainInvalidConfig = 10386] = "DomainInvalidConfig", e[e.DomainInvalidAutorenewConfig = 10387] = "DomainInvalidAutorenewConfig", e[e.DomainConfigUpdateFailure = 10388] = "DomainConfigUpdateFailure", e[e.ServerRedirectPrimaryInvalid = 10389] = "ServerRedirectPrimaryInvalid", e[e.UserTosInvalid = 10394] = "UserTosInvalid", e[e.UserTosDecline = 10395] = "UserTosDecline", e[e.UserNothingToCreate = 10396] = "UserNothingToCreate", e[e.FlushFailedBeforeUndelete = 10397] = "FlushFailedBeforeUndelete", e[e.ServerUndeleteFailed = 10398] = "ServerUndeleteFailed", e[e.CustomerUpdateFailed = 10401] = "CustomerUpdateFailed", e[e.ServerInvalidStorageNotVcs = 10402] = "ServerInvalidStorageNotVcs", e[e.CustomerGetFailed = 10403] = "CustomerGetFailed", e[e.CustomerGetCorrupted = 10404] = "CustomerGetCorrupted", e[e.PlanInit = 10405] = "PlanInit", e[e.PaymentUpdateFailed = 10406] = "PaymentUpdateFailed", e[e.NotACustomer = 10408] = "NotACustomer", e[e.CustomerNoInvoicesFound = 10409] = "CustomerNoInvoicesFound", e[e.DeleteAllStorageProviders = 10410] = "DeleteAllStorageProviders", e[e.DeleteAStorageProvider = 10411] = "DeleteAStorageProvider", e[e.AssetInvalidScheme = 10415] = "AssetInvalidScheme", e[e.AssetInvalidMetadata = 10416] = "AssetInvalidMetadata", e[e.AssetsInsertFailure = 10417] = "AssetsInsertFailure", e[e.AssetUploadMissing = 10418] = "AssetUploadMissing", e[e.AssetImageOutputSetFailure = 10419] = "AssetImageOutputSetFailure", e[e.AssetLoadImageFailure = 10420] = "AssetLoadImageFailure", e[e.AssetMissingFile = 10421] = "AssetMissingFile", e[e.AssetsFailedToStore = 10422] = "AssetsFailedToStore", e[e.AssetsUploadFailed = 10423] = "AssetsUploadFailed", e[e.AssetsInvalidId = 10424] = "AssetsInvalidId", e[e.AssetDeleteFailure = 10425] = "AssetDeleteFailure", e[e.AssetsGetFailed = 10426] = "AssetsGetFailed", e[e.StoragePairNotLoggedIn = 10427] = "StoragePairNotLoggedIn", e[e.CodePassEncryptFailure = 10429] = "CodePassEncryptFailure", e[e.AssetsRotateFail = 10445] = "AssetsRotateFail", e[e.AssetsCropFail = 10446] = "AssetsCropFail", e[e.AssetsResizeFail = 10447] = "AssetsResizeFail", e[e.AssetOutput = 10450] = "AssetOutput", e[e.AssetInvalidType = 10452] = "AssetInvalidType", e[e.RequestExpiresInvalid = 10454] = "RequestExpiresInvalid", e[e.ServerInvalidPath = 10455] = "ServerInvalidPath", e[e.ServerNodeFiltered = 10456] = "ServerNodeFiltered", e[e.ServerUnsupportedContent = 10457] = "ServerUnsupportedContent", e[e.VirusFound = 10458] = "VirusFound", e[e.FileTooBig = 10459] = "FileTooBig", e[e.InvalidUrlForConversion = 10460] = "InvalidUrlForConversion", e[e.ConversionSizeTooSmall = 10461] = "ConversionSizeTooSmall", e[e.TransferFailed = 10463] = "TransferFailed", e[e.ImageAssetProcessing = 10464] = "ImageAssetProcessing", e[e.AssetImageDisabled = 10485] = "AssetImageDisabled", e[e.ImageResizeDisabled = 10486] = "ImageResizeDisabled", e[e.ServerHtmlRenderDenied = 10487] = "ServerHtmlRenderDenied", e[e.ServerIndexFilesDenied = 10488] = "ServerIndexFilesDenied", e[e.UploadObjectInit = 10489] = "UploadObjectInit", e[e.UploadFailedToInsert = 10500] = "UploadFailedToInsert", e[e.UploadTooLargeForAcct = 10501] = "UploadTooLargeForAcct", e[e.UploadTooManyChunksForAcct = 10502] = "UploadTooManyChunksForAcct", e[e.UploadTooManySessions = 10504] = "UploadTooManySessions", e[e.UploadChunkSizeSmall = 10505] = "UploadChunkSizeSmall", e[e.UploadChunkSizeBig = 10506] = "UploadChunkSizeBig", e[e.UploadIdInvalid = 10507] = "UploadIdInvalid", e[e.UploadIdNotFound = 10508] = "UploadIdNotFound", e[e.UploadDeleteFailed = 10509] = "UploadDeleteFailed", e[e.UploadChunkSize = 10511] = "UploadChunkSize", e[e.UploadChunkHashFailed = 10512] = "UploadChunkHashFailed", e[e.UploadChunkStoreFailed = 10513] = "UploadChunkStoreFailed", e[e.UploadChunkOrderInvalid = 10514] = "UploadChunkOrderInvalid", e[e.UploadDeleteChunkFailed = 10515] = "UploadDeleteChunkFailed", e[e.UserCreate = 10517] = "UserCreate", e[e.BillingCreateFreeCustomer = 10518] = "BillingCreateFreeCustomer", e[e.CheckUserInsert = 10519] = "CheckUserInsert", e[e.UploadSetStateFailed = 10520] = "UploadSetStateFailed", e[e.UploadNoChunks = 10521] = "UploadNoChunks", e[e.UploadAssembleMissingChunks = 10522] = "UploadAssembleMissingChunks", e[e.UploadAssembleEnqueueFailed = 10523] = "UploadAssembleEnqueueFailed", e[e.BillingCustomerMissing = 10524] = "BillingCustomerMissing", e[e.UserTrialEndFailed = 10527] = "UserTrialEndFailed", e[e.OauthFallthrough = 10529] = "OauthFallthrough", e[e.CookiesMissing = 10530] = "CookiesMissing", e[e.WebhookStripeBody = 10538] = "WebhookStripeBody", e[e.CreateCheckoutSession = 10539] = "CreateCheckoutSession", e[e.InvalidUrl = 10540] = "InvalidUrl", e[e.VaultFailure = 10541] = "VaultFailure", e[e.OrgDomainInvalid = 10542] = "OrgDomainInvalid", e[e.OrgCreate = 10543] = "OrgCreate", e[e.OrgConfigInvalid = 10544] = "OrgConfigInvalid", e[e.OrgNotAuthorized = 10545] = "OrgNotAuthorized", e[e.OrgNothingToUpdate = 10547] = "OrgNothingToUpdate", e[e.OrgCommitChanges = 10548] = "OrgCommitChanges", e[e.OrgDomainMismatch = 10549] = "OrgDomainMismatch", e[e.SubscriptionOrgCloseCancelFailed = 10550] = "SubscriptionOrgCloseCancelFailed", e[e.WsInvalidConfigName = 10555] = "WsInvalidConfigName", e[e.WorkspaceConfigNameInUse = 10556] = "WorkspaceConfigNameInUse", e[e.OrgConfigNameInUse = 10557] = "OrgConfigNameInUse", e[e.WsConfigInvalid = 10558] = "WsConfigInvalid", e[e.WsCreate = 10559] = "WsCreate", e[e.WsCommitChanges = 10561] = "WsCommitChanges", e[e.WsNothingToUpdate = 10562] = "WsNothingToUpdate", e[e.WsNameMismatch = 10563] = "WsNameMismatch", e[e.ShareInvalidConfigName = 10564] = "ShareInvalidConfigName", e[e.ShareConfigNameInUse = 10565] = "ShareConfigNameInUse", e[e.ShareConfigInvalid = 10566] = "ShareConfigInvalid", e[e.ShareCreate = 10567] = "ShareCreate", e[e.ShareCommitChanges = 10568] = "ShareCommitChanges", e[e.ShareInvalidExpires = 10569] = "ShareInvalidExpires", e[e.ShareNothingToUpdate = 10570] = "ShareNothingToUpdate", e[e.ShareNameMismatch = 10571] = "ShareNameMismatch", e[e.ProfileInvalidName = 10580] = "ProfileInvalidName", e[e.ProfileNotFound = 10581] = "ProfileNotFound", e[e.ProfileClosed = 10582] = "ProfileClosed", e[e.ProfileLocked = 10583] = "ProfileLocked", e[e.ProfileSuspended = 10584] = "ProfileSuspended", e[e.ProfileDmca = 10585] = "ProfileDmca", e[e.ProfileInsufficientPermissions = 10586] = "ProfileInsufficientPermissions", e[e.UserNotValidated = 10587] = "UserNotValidated", e[e.MembershipExists = 10599] = "MembershipExists", e[e.MembershipPermissionDenied = 10601] = "MembershipPermissionDenied", e[e.MembershipInviteInvalidEmail = 10602] = "MembershipInviteInvalidEmail", e[e.ExpiresInvalid = 10603] = "ExpiresInvalid", e[e.MembershipCommitChanges = 10604] = "MembershipCommitChanges", e[e.MembershipUserSame = 10605] = "MembershipUserSame", e[e.MembershipNotExists = 10606] = "MembershipNotExists", e[e.MembershipDeleteFailed = 10607] = "MembershipDeleteFailed", e[e.ProfileTypeInvalid = 10610] = "ProfileTypeInvalid", e[e.ProfileNotLoaded = 10611] = "ProfileNotLoaded", e[e.ProfilePermissionValidationError = 10612] = "ProfilePermissionValidationError", e[e.MembershipNoChanges = 10613] = "MembershipNoChanges", e[e.MembershipOwnerSame = 10614] = "MembershipOwnerSame", e[e.MembershipDomainDisabled = 10616] = "MembershipDomainDisabled", e[e.MembershipDomainDenied = 10617] = "MembershipDomainDenied", e[e.MembershipInviteInvalidId = 10618] = "MembershipInviteInvalidId", e[e.MembershipJoinDenied = 10619] = "MembershipJoinDenied", e[e.UpdatePermissionDenied = 10620] = "UpdatePermissionDenied", e[e.MembershipRemovalOnlyOwner = 10621] = "MembershipRemovalOnlyOwner", e[e.ChildCreationFailed = 10622] = "ChildCreationFailed", e[e.AuthThrottleKeyInvalid = 10623] = "AuthThrottleKeyInvalid", e[e.InvalidProfileIdInput = 10624] = "InvalidProfileIdInput", e[e.MembershipInviteAddFailed = 10625] = "MembershipInviteAddFailed", e[e.MembershipInviteInvalidKey = 10626] = "MembershipInviteInvalidKey", e[e.MembershipInviteInvalidAction = 10627] = "MembershipInviteInvalidAction", e[e.MembershipInviteUseFailed = 10628] = "MembershipInviteUseFailed", e[e.MembershipInviteInvalidMessage = 10629] = "MembershipInviteInvalidMessage", e[e.MembershipInviteGetInvitationFailed = 10630] = "MembershipInviteGetInvitationFailed", e[e.MembershipInviteInvalidState = 10631] = "MembershipInviteInvalidState", e[e.UploadOrgDenied = 10633] = "UploadOrgDenied", e[e.UploadGetChunksFailed = 10634] = "UploadGetChunksFailed", e[e.UploadChunkMissing = 10635] = "UploadChunkMissing", e[e.OrgNotSubscribed = 10639] = "OrgNotSubscribed", e[e.UploadAssembleFailed = 10640] = "UploadAssembleFailed", e[e.UploadTooLarge = 10641] = "UploadTooLarge", e[e.UploadCompleteFailed = 10642] = "UploadCompleteFailed", e[e.PaymentIntentCreateFailed = 10660] = "PaymentIntentCreateFailed", e[e.OrgCloseVaultFailed = 10661] = "OrgCloseVaultFailed", e[e.VaultCreate = 10662] = "VaultCreate", e[e.InstanceCreate = 10663] = "InstanceCreate", e[e.BillingPaymentRequired = 10664] = "BillingPaymentRequired", e[e.BillingPaymentMethodInvalid = 10665] = "BillingPaymentMethodInvalid", e[e.MgmtConsoleMissingUser = 10666] = "MgmtConsoleMissingUser", e[e.MgmtConsoleLoginFailure = 10667] = "MgmtConsoleLoginFailure", e[e.InvalidTransformation = 10668] = "InvalidTransformation", e[e.UnableToRender = 10669] = "UnableToRender", e[e.UnableToRetrievePreview = 143705] = "UnableToRetrievePreview", e[e.UploadFileNotCompleted = 165170] = "UploadFileNotCompleted", e[e.NotAllowedUpdateShare = 107670] = "NotAllowedUpdateShare", e[e.CreateShareFieldType = 169650] = "CreateShareFieldType", e[e.CreateShareFieldMissing = 205516] = "CreateShareFieldMissing", e[e.UnexpectedError = 90211] = "UnexpectedError", e[e.RequestAborted = 90212] = "RequestAborted", e[e.ShareCannotViewMembers = 161224] = "ShareCannotViewMembers", e[e.ShareNotFound = 144499] = "ShareNotFound", e[e.FileNotFound = 105005] = "FileNotFound", e[e.CannotMoveFile = 173657] = "CannotMoveFile", e[e.CannotDeleteFile = 133557] = "CannotDeleteFile", e.CorsError = "cors", e[e.UnknownError = 99999] = "UnknownError", e))(Oe || {});
const we = "x-ve-debug-routing", _e = "cf-ray", xt = "x-ve-debug";
class Ke extends Error {
  constructor() {
    super(...arguments);
    O(this, "response");
    O(this, "code");
    O(this, "text");
  }
}
const Lt = globalThis.fetch, _t = globalThis.FormData, kt = (e, t) => {
  const n = new _t();
  for (const a in e)
    Object.prototype.hasOwnProperty.call(e, a) && e[a] !== void 0 && (a === "chunk" ? n.append(a, e[a], t) : n.append(a, e[a]));
  return n;
}, vt = (e) => {
  const t = [];
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && e[n] !== void 0) {
      const a = typeof e[n] == "object" && e[n] !== null ? JSON.stringify(e[n]) : e[n];
      t.push(
        `${encodeURIComponent(n)}=${encodeURIComponent(a)}`
      );
    }
  return t.join("&");
}, ft = (e) => {
  if (typeof window > "u")
    return;
  const t = e.get(_e), n = e.get(xt);
  n && window.localStorage.setItem(we, n), t && window.localStorage.setItem(_e, t);
}, ke = (e) => {
  if (typeof window > "u")
    return "";
  const t = `${e}=`, n = window.document.cookie.split(";");
  for (let a = 0; a < n.length; a++) {
    let h = n[a];
    for (; h.charAt(0) === " "; )
      h = h.substring(1);
    if (h.indexOf(t) === 0)
      return h.substring(t.length, h.length);
  }
  return "";
}, He = () => {
  const e = window.localStorage.getItem(we), t = [], n = ke("ve-authorization"), a = ke("ve_br_key");
  n && t.push(`ve-authorization=${n}`), a && t.push(`ve_br_key=${a}`);
  const h = t.join(";"), D = De();
  return Object.fromEntries(
    Object.entries({
      ...h && !D ? { Cookie: h } : {},
      "x-ve-debug-routing": e,
      "ve-authorization": n && !D ? n : void 0,
      "x-ve-br-key": a && !D ? a : void 0
    }).filter(([C, u]) => u !== void 0)
  );
}, De = () => location.origin.includes(ut), Ft = async (e, t) => {
  var K, _;
  const n = new Ke(), a = {
    ...e,
    credentials: De() || e.includeCredentials ? "include" : "omit",
    headers: {
      ...e.headers,
      ...He()
    }
  }, h = await Lt(t, a);
  ft(h.headers);
  const D = h.headers.get("Content-Type"), g = D ? D.includes("application/json") : !1, C = D ? /^(image|audio|video|application\/octet-stream|application\/x-mpegurl|application\/pdf)/i.test(
    D
  ) : !1;
  let u;
  if (g ? (u = await h.json(), u.data && (u = u.data)) : C ? u = await h.blob() : u = await h.text(), !(200 <= h.status && h.status < 300)) {
    const I = (K = u == null ? void 0 : u.error) == null ? void 0 : K.text;
    throw n.message = I || h.statusText, n.response = h, n.code = (_ = u == null ? void 0 : u.error) == null ? void 0 : _.code, n.text = I, n;
  }
  return u;
}, Ut = (e, t, n) => {
  const a = new Ke(), h = n || new XMLHttpRequest();
  return new Promise((D, g) => {
    const C = e.method;
    h.upload.onprogress = (u) => {
      e.onProgress && e.onProgress(u);
    }, h.withCredentials = !!(De() || e.includeCredentials), h.open(C, t);
    for (const [u, $] of Object.entries(e.headers || {}))
      h.setRequestHeader(u, $);
    Object.entries(He()).forEach(([u, $]) => {
      h.setRequestHeader(u, $);
    }), h.onreadystatechange = () => {
      var u, $;
      if (h.readyState === 4) {
        const K = 200 <= h.status && h.status < 300;
        let _;
        try {
          _ = JSON.parse(h.responseText);
        } catch {
          _ = h.responseText;
        }
        if (K)
          D(_);
        else {
          const I = h.status === 0, B = I ? "Request canceled" : ((u = _ == null ? void 0 : _.error) == null ? void 0 : u.text) || h.statusText;
          a.message = B, a.response = _, a.code = I ? Oe.RequestAborted : ($ = _ == null ? void 0 : _.error) == null ? void 0 : $.code, a.text = B, g(a);
        }
      }
    }, e.onAbort && e.onAbort.then(() => {
      h.abort();
    }), h.send(e.body);
  });
}, zt = async (e, t, n, a) => {
  const h = t.filter(Boolean);
  a && console.log("API Call:", ...h);
  try {
    const D = await e(...t);
    if ("result" in D && D.result === !1)
      throw D.error;
    return a && console.log("API Response:", ...h, { response: D }), D;
  } catch (D) {
    const g = { ...D, apiUrl: h[0] }, C = new Error().stack ?? "";
    return a && (console.error("API Error:", ...h, g), console.error("API Error Trace:", C)), n ? {
      result: !1,
      error: n(g, async () => await e(...t), C) ?? g
    } : {
      result: !1,
      error: g
    };
  }
}, $t = () => De() ? mt : location.origin, Ye = (e) => `/api/current${e}`, be = (e, t) => {
  const n = $t();
  return t ? `${e}` : `${n}${Ye(e)}`;
};
let Te, Ze, Ae;
const Gt = () => Te, Vt = (e) => {
  Te = e;
}, wt = (e) => {
  Ze = e;
}, Ht = (e) => {
  Ae = e;
}, Ie = async (e, t, n, a = {}, h, D) => {
  const g = be(t, h);
  return a.method = e, a.headers || (a.headers = {}), a.headers.accept = "application/json", Te && a.headers.authorization === void 0 && (a.headers.authorization = `Bearer ${Te}`), n && (a.multipart ? a.body = kt(n, a.filename) : (a.headers["content-type"] = "application/x-www-form-urlencoded", a.body = vt(n))), await zt(
    async () => {
      let u;
      try {
        typeof window < "u" && e === "POST" && a.multipart ? u = await Ut(a, g, D) : u = await Ft(a, g);
      } catch ($) {
        const K = $;
        u = {
          result: !1,
          error: {
            code: $.code || Oe.UnknownError,
            text: K.message,
            apiUrl: g
          }
        };
      }
      if ("result" in u && u.result === !1)
        throw u.error;
      return u;
    },
    [t, e, n],
    Ze,
    Ae
  );
}, Yt = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (e, t) => async (...n) => {
    for (let a = 1; a <= e; a++) {
      if (a === e)
        return await t(...n);
      try {
        return await t(...n);
      } catch {
      }
    }
  }
), Q = (e, t) => {
  const n = {};
  for (const h in t) {
    const D = t[h];
    D !== void 0 && (n[h] = D);
  }
  const a = new URLSearchParams(n).toString();
  return `${e}${a ? `?${a}` : ""}`;
}, m = (e, t) => Ie("GET", e, void 0, t), j = (e, t, n, a, h) => Ie("POST", e, t, n, a, h), V = (e, t, n) => Ie("DELETE", e, t, n), Xl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RequestError: Ke,
  del: V,
  get: m,
  getAuthToken: Gt,
  getBaseUrl: be,
  post: j,
  request: Ie,
  retry: Yt,
  setApiLogEnabled: Ht,
  setAuthToken: Vt,
  setErrorInterceptor: wt,
  url: Q
}, Symbol.toStringTag, { value: "Module" })), T = {
  AUTH: "/user/sso/signin",
  ALERTS_EVENTS: "/events",
  ANALYTICS: "/analytics",
  APPS: "/apps",
  ASSETS: {
    all: "/assets",
    single: "/asset"
  },
  BILLING: "/billing",
  CDN_PROVIDER: "/cdn/providers",
  DOMAIN_BINDING: "/domains/bindings",
  FILE_FOLDER: "/server/list",
  LOG: "/log",
  METADATA: "/metadata",
  PLATFORM: "/system",
  POLL: "/activity/poll",
  SERVER: "/server",
  STORAGE: "/storage",
  TEAMS: "/member/list",
  TWO_FACTOR: "/user/2factor",
  UPLOAD: "/upload",
  STATISTICS: "/stats",
  USER: "/user",
  USERS: "/users",
  PAYMENT: "https://api.stripe.com/v1",
  ORGANIZATION: "/org",
  WORKSPACE: "/workspace",
  WORKSPACES: "/workspaces",
  SHARE: "/share",
  SHARES: "/shares",
  REALTIME: "/realtime",
  WEBSOCKET: "/websocket",
  QUICK_SHARES: "/quickshares",
  QUICK_SHARE: "/quickshare",
  EVENTS: "/events"
}, Zt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NAME_SPACES: T
}, Symbol.toStringTag, { value: "Module" })), At = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/activity/poll</strong>?fields={{fields}}&wait={{wait}}&lastactivity={{lastactivity}}&updated={{updated}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *     results: number
   *     activity: Record<string, Date> | null
   * }
   * ```
   * URL_PARAMETER = OPTIONAL fields & OPTIONAL wait & OPTIONAL lastactivity & OPTIONAL updated
   */
  POLL: (e) => `${T.POLL}/${e}`
}, pt = ({ entityId: e, fields: t, ...n }) => m(
  Q(At.POLL(e), {
    fields: t == null ? void 0 : t.join(","),
    ...n
  })
), Wt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  poll: pt
}, Symbol.toStringTag, { value: "Module" })), Bt = async (e) => {
  const t = await e;
  return t.events.forEach((n) => {
    n.created = J(n.created), n.acknowledged = J(n.acknowledged), n.resolved = J(n.resolved);
  }), t;
}, me = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/events</strong>?limit={{limit}}&alarm={{alarm}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type responseType = {
   *  results: number
   *  events: Event[]
   * }
   * ```
   * URL_PARAMETER = OPTIONAL limit & OPTIONAL alarm
   */
  EVENTS: () => `${T.ALERTS_EVENTS}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/events/</strong>{{server}}/?limit={{limit}}&alarm={{alarm}}</span>
   *
   * REQUIRES AUTH
   *
   * URL_PARAMETER = REQUIRES server & OPTIONAL limit & OPTIONAL alarm
   */
  SERVER_EVENTS: (e) => `${T.ALERTS_EVENTS}/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/events/ack/</strong>{{event_id}}</span>
   *
   * REQUIRES AUTH
   *
   * URL_PARAMETER = REQUIRES event_id
   */
  ACKNOWLEDGE: (e) => `${T.ALERTS_EVENTS}/ack/${e}`,
  /**
   * * ENDPOINT: <span style="color:red"><strong>/events/ack/server/</strong>{{server}}</span>
   *
   * REQUIRES AUTH
   *
   * URL_PARAMETER = REQUIRES server
   */
  SERVER_ACKNOWLEDGE: (e) => `${T.ALERTS_EVENTS}/ack/server/${e}`
}, Jt = async (e = {}) => Bt(m(Q(me.EVENTS(), e))), Qt = ({
  server: e,
  ...t
}) => m(Q(me.SERVER_EVENTS(e), t)), qt = ({ event_id: e }) => j(me.ACKNOWLEDGE(e)), en = ({ server: e }) => j(me.SERVER_ACKNOWLEDGE(e)), tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  acknowledge: qt,
  acknowledgeServer: en,
  events: Jt,
  eventsForServer: Qt
}, Symbol.toStringTag, { value: "Module" })), ie = {
  // DON'T EXIST
  PROVIDERS_LIST: () => `${T.ANALYTICS}/providers/list`,
  // DON'T EXIST
  PROVIDER_DETAILS: (e) => `${T.ANALYTICS}/providers/details/${e}`,
  // DON'T EXIST
  FILTER_VALIDATE: (e) => `${T.ANALYTICS}/validate/filter?filter=${encodeURIComponent(e)}`,
  // DON'T EXIST
  CREATE_PROFILE: () => `${T.ANALYTICS}`,
  // DON'T EXIST
  PROFILE_DETAILS: (e) => `${T.ANALYTICS}/details/${e}`,
  // DON'T EXIST
  PROFILES_LIST: () => `${T.ANALYTICS}/list`,
  // DON'T EXIST
  UPDATE_PROFILE: (e) => `${T.ANALYTICS}/update/${e}`,
  // DON'T EXIST
  DELETE_PROFILE: (e) => `${T.ANALYTICS}/${e}`
}, nn = async () => {
  const e = await m(ie.PROVIDERS_LIST());
  return e.providers.forEach(W), e;
}, an = async ({ name: e }) => {
  const t = await m(ie.PROVIDER_DETAILS(e));
  return W(t.provider), t;
}, sn = ({ filter: e }) => m(ie.FILTER_VALIDATE(e)), ln = (e) => j(ie.CREATE_PROFILE(), e), on = async ({ profile: e }) => {
  const t = await m(ie.PROFILE_DETAILS(e));
  return W(t.profile), t;
}, cn = async () => {
  const e = await m(ie.PROFILES_LIST());
  return e.profiles.forEach(W), e;
}, dn = ({
  profile: e,
  token: t,
  event_name: n
}) => j(ie.UPDATE_PROFILE(e), { token: t, event_name: n }), Pn = ({ profile: e }) => V(ie.DELETE_PROFILE(e)), Sn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createProfile: ln,
  deleteProfile: Pn,
  listProfiles: cn,
  listProviders: nn,
  profileDetails: on,
  providerDetails: an,
  updateProfile: dn,
  validateFilter: sn
}, Symbol.toStringTag, { value: "Module" })), ee = {
  // DON'T EXIST
  APPS_LIST: () => `${T.APPS}/providers/list`,
  // DON'T EXIST
  LINKED_APPS_LIST: () => `${T.APPS}/providers/list/linked`,
  // DON'T EXIST
  OAUTH: (e) => `${T.APPS}/link/${e}`,
  // DON'T EXIST
  APP_DETAILS: (e) => `${T.APPS}/providers/details/${e}`,
  // DON'T EXIST
  CREATE_CONFIG: (e) => `${T.APPS}/${e}`,
  // DON'T EXIST
  CONFIG_LIST: () => `${T.APPS}/list`,
  // DON'T EXIST
  CONFIG_DETAILS: (e, t, n) => `${T.APPS}/details/${e}/${t}/${n}`,
  // DON'T EXIST
  DELETE_CONFIG: (e, t, n) => `${T.APPS}/${e}/${t}/${n}`,
  // DON'T EXIST
  DELETE_APP: (e) => `${T.APPS}/provides/${e}`
}, hn = async () => {
  const e = await m(ee.APPS_LIST());
  return e.providers.forEach(W), e;
}, Tn = async () => {
  const e = await m(ee.LINKED_APPS_LIST());
  return e.providers || (e.providers = []), e.providers.forEach(W), e;
}, Mn = ({ provider: e }) => m(ee.OAUTH(e)), Dn = ({
  provider: e,
  ...t
}) => j(ee.OAUTH(e), t), In = async ({ name: e }) => {
  const t = await m(ee.APP_DETAILS(e));
  return W(t.provider), t;
}, mn = ({
  app: e,
  ...t
}) => j(ee.CREATE_CONFIG(e), t), un = async () => {
  const e = await m(ee.CONFIG_LIST());
  return e.configs.forEach(W), e;
}, jn = async ({
  app: e,
  type: t,
  name: n
}) => {
  const a = await m(ee.CONFIG_DETAILS(e, t, n));
  return W(a.config.provider), W(a.config.config), a;
}, gn = ({
  app: e,
  type: t,
  name: n
}) => V(ee.DELETE_CONFIG(e, t, n)), Nn = ({ app: e }) => V(ee.DELETE_APP(e)), Cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  appDetails: In,
  configDetails: jn,
  configList: un,
  createConfig: mn,
  deleteApp: Nn,
  deleteConfig: gn,
  getOAuthLink: Mn,
  listApps: hn,
  listLinkedApps: Tn,
  processOAuthCode: Dn
}, Symbol.toStringTag, { value: "Module" })), ue = {
  // DON'T EXIST
  ADD_ASSET: () => `${T.ASSETS.single}`,
  // DON'T EXIST
  GET_ASSET: (e) => `${T.ASSETS.all}/${e}`,
  // DON'T EXIST
  GET_ASSETS: () => `${T.ASSETS.all}`,
  // DON'T EXIST
  DELETE_ASSET: (e) => `${T.ASSETS.all}/${e}`
}, yn = (e) => j(ue.ADD_ASSET(), e, {
  multipart: !0
}), Rn = async ({ id: e }) => {
  const t = await m(ue.GET_ASSET(e));
  return t.asset.created = J(t.asset.created), t;
}, En = async () => {
  const e = await m(
    ue.GET_ASSETS()
  );
  return e.assets.forEach((t) => t.created = J(t.created)), e;
}, On = ({ id: e }) => V(ue.DELETE_ASSET(e)), Kn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addAsset: yn,
  deleteAsset: On,
  getAsset: Rn,
  getAssets: En
}, Symbol.toStringTag, { value: "Module" })), q = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/sso/signin/apple</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean
   *   provider: string
   *   redirect_url: string
   *   return_url: string
   * }
   * ```
   */
  APPLE: () => `${T.AUTH}/apple`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/sso/signin/google</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean
   *   provider: string
   *   redirect_url: string
   *   return_url: string
   * }
   * ````
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *  state: string
   *  code: string
   *  scope: string
   *  authuser: string
   *  hd: string
   *  prompt: string
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *  result: boolean
   *  provider: string
   *  email: string
   *  token: string
   * }
   * ```
   */
  GOOGLE: () => `${T.AUTH}/google`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/sso/signin/facebook</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean
   *   provider: string
   *   redirect_url: string
   *   return_url: string
   * }
   * ```
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   state: string
   *   code: string
   *   scope: string
   *   authuser: string
   *   hd: string
   *   prompt: string
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   *   provider: string
   *   email: string
   *   token: string
   * }
   * ```
   */
  FACEBOOK: () => `${T.AUTH}/facebook`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/sso/signin/microsoft</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean
   *   provider: string
   *   redirect_url: string
   *   return_url: string
   * }
   * ```
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   state: string
   *   code: string
   *   scope: string
   *   authuser: string
   *   hd: string
   *   prompt: string
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   *   provider: string
   *   email: string
   *   token: string
   * }
   * ```
   */
  MICROSOFT: () => `${T.AUTH}/microsoft`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/auth</strong></span>
   *
   * METHOD: GET
   *
   * Authorization accepts plain text credentials through HTTP BASIC AUTH
   * (btoa(`${email}:${password}`))
   *
   * ```ts
   * type ResponseType = {
   *   result: boolean
   *   expires_in: number
   *   auth_token: string
   *   2factor: boolean
   * }
   * ```
   */
  SIGN_IN: () => `${T.USER}/auth`,
  CHECK_AUTH: () => `${T.USER}/auth/check/`,
  CHECK_WEBSOCKET_AUTH: (e) => `${T.WEBSOCKET}/auth/${e}`,
  CHECK_REALTIME_AUTH: (e) => `${T.REALTIME}/auth/${e}`
}, bn = typeof window < "u" ? window.btoa : (e) => Buffer.from(e).toString("base64"), rn = ({
  email: e,
  password: t
}) => m(q.SIGN_IN(), {
  headers: {
    authorization: `Basic ${bn(`${e}:${t}`)}`
  }
}), Xn = ({ memo: e } = {}) => j("/user/key", { memo: e }), xn = ({ id: e }) => m(`/user/key/${e}`), Ln = async () => {
  const e = await m("/user/keys");
  return e.api_keys.forEach((t) => t.created = J(t.created)), e;
}, _n = ({ id: e }) => V(`/user/key/${e}`), kn = () => m(q.APPLE(), {
  includeCredentials: !0
}), vn = () => m(q.GOOGLE(), {
  includeCredentials: !0
}), fn = (e) => {
  const t = `${q.GOOGLE()}?${new URLSearchParams(e).toString()}`;
  return j(t.toString());
}, Fn = () => m(q.FACEBOOK(), {
  includeCredentials: !0
}), Un = (e) => j(q.FACEBOOK(), e), zn = () => m(q.MICROSOFT(), {
  includeCredentials: !0
}), $n = (e) => j(q.MICROSOFT(), e), Gn = () => m(q.CHECK_AUTH()), Vn = (e) => m(q.CHECK_WEBSOCKET_AUTH(e)), wn = (e) => m(q.CHECK_REALTIME_AUTH(e)), Hn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  checkSession: Gn,
  createKey: Xn,
  deleteKey: _n,
  getAppleRedirectURL: kn,
  getFacebookRedirectURL: Fn,
  getFacebookSSOToken: Un,
  getGoogleRedirectURL: vn,
  getGoogleSSOToken: fn,
  getMicrosoftRedirectURL: zn,
  getMicrosoftSSOToken: $n,
  keyDetails: xn,
  listKeys: Ln,
  realtimeAuth: wn,
  signIn: rn,
  websocketAuth: Vn
}, Symbol.toStringTag, { value: "Module" })), ae = {
  PLANS_LIST: `${T.ORGANIZATION}${T.BILLING}/plan/list`,
  KEYS: `${T.ORGANIZATION}${T.BILLING}/keys`,
  UPDATE_SUBSCRIPTION: (e) => `${T.ORGANIZATION}/${e}${T.BILLING}`,
  GET_SUBSCRIPTION_DETAILS: (e) => `${T.ORGANIZATION}/${e}${T.BILLING}/details`,
  GET_CURRENT_PLAN: (e) => `${T.ORGANIZATION}/${e}${T.BILLING}/plan/details`,
  CANCEL_SUBSCRIPTION: (e) => `${T.ORGANIZATION}/${e}${T.BILLING}`,
  GET_BILLING_USAGE_MEMBERS: (e) => `${T.ORGANIZATION}/${e}${T.BILLING}/usage/members/list`,
  GET_BILLING_USAGE_STORAGE: (e) => `${T.ORGANIZATION}/${e}${T.BILLING}/usage/storage/list`,
  GET_BILLING_METERS: (e, t) => `${T.ORGANIZATION}/${e}${T.BILLING}/usage/meters/list?meter=${t}`
}, Yn = () => m(ae.PLANS_LIST), Zn = () => m(ae.KEYS), An = (e, t) => j(ae.UPDATE_SUBSCRIPTION(e), {
  billing_plan: t
}), pn = (e) => m(
  ae.GET_SUBSCRIPTION_DETAILS(e)
), Wn = (e) => m(ae.GET_CURRENT_PLAN(e)), Bn = (e) => V(ae.CANCEL_SUBSCRIPTION(e)), Jn = (e) => m(ae.GET_BILLING_USAGE_MEMBERS(e)), Qn = (e) => m(ae.GET_BILLING_USAGE_STORAGE(e)), qn = (e, t) => m(ae.GET_BILLING_METERS(e, t)), ea = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cancelSubscription: Bn,
  createOrUpdateSubscription: An,
  getBillingUsageMembers: Jn,
  getBillingUsageStorage: Qn,
  getCurrentPlan: Wn,
  getKeys: Zn,
  getMeters: qn,
  getPlanList: Yn,
  getSubscriptionDetails: pn
}, Symbol.toStringTag, { value: "Module" })), pe = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/cdn/providers/list</strong></span>
   *
   * INTERNAL SERVER ERROR (500)
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *     results: number
   *     providers: CDN[]
   * }
   * ````
   */
  CDNS_LIST: () => `${T.CDN_PROVIDER}/list`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/cdn/providers/details/</strong>{{cdn_name}}</span>
   *
   * INTERNAL SERVER ERROR (500)
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *     provider: CDN
   * }
   * ```
   * URL_PARAMETER = REQUIRES cdn_name
   */
  CDN_DETAILS: (e) => `${T.CDN_PROVIDER}/details/${e}`
}, ta = async () => {
  const e = await m(pe.CDNS_LIST());
  return e.providers.forEach(W), e;
}, na = async ({ name: e }) => {
  const t = await m(pe.CDN_DETAILS(e));
  return W(t.provider), t;
}, aa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CDNDetails: na,
  listCDNs: ta
}, Symbol.toStringTag, { value: "Module" })), je = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/domains/bindings/</strong>{{vanity_domain}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   origin_domain: string
   *   origin_name: string
   *   vanity_name?: string
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   dns: string
   *   server: string
   *   ips: string[]
   *   status: string
   * }
   * ```
   * URL_PARAMETER = REQUIRES vanity_domain
   */
  CREATE_BINDING: (e) => `${T.DOMAIN_BINDING}/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/domains/bindings/list</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   results: number
   *   bindings: Omit<DomainBinding, 'status' | 'ssl'>[]
   * }
   * ```
   */
  BINDING_LIST: () => `${T.DOMAIN_BINDING}/list`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/domains/bindings/details/</strong>{{domain}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = { binding: DomainBinding }
   * ```
   * URL_PARAMETER = REQUIRES domain
   */
  BINDING_DETAILS: (e) => `${T.DOMAIN_BINDING}/details/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/domains/bindings/</strong>{{vanity_domain}}/<span style="color:black" >{{if vanity_name exists <span style="color:red">vanity_name</span> else none}}</span></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: DELETE
   *
   * URL_PARAMETER = REQUIRES vanity_domain & OPTIONAL vanity_name
   */
  DELETE_BINDING: (e, t) => `${T.DOMAIN_BINDING}/${e}${t ? `/${t}` : ""}`
}, sa = ({
  vanity_domain: e,
  ...t
}) => j(je.CREATE_BINDING(e), t), ia = async () => {
  const e = await m(je.BINDING_LIST());
  return e.bindings.forEach(W), e;
}, la = async ({ domain: e }) => {
  const t = await m(
    je.BINDING_DETAILS(e)
  );
  return W(t.binding), t;
}, oa = ({
  vanity_domain: e,
  vanity_name: t
}) => V(je.DELETE_BINDING(e, t)), ca = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bindingDetails: la,
  bindingList: ia,
  createBinding: sa,
  deleteBinding: oa
}, Symbol.toStringTag, { value: "Module" })), da = {
  SEARCH: () => `${T.EVENTS}/search`
}, Pa = (e) => m(Q(da.SEARCH(), e)), Sa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  search: Pa
}, Symbol.toStringTag, { value: "Module" })), te = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/check/</strong>{{server}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   *
   * URL_PARAMETER = REQUIRES server
   */
  CHECK_SERVER_NAME: (e) => `${T.SERVER}/check/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/validate/filter</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   *
   * type BodyType = { filter: string }
   */
  VALIDATE_FILTER: () => `${T.SERVER}/validate/filter`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   analytics = null,
   *   name: string
   *   storage: string
   *   domain?: string // ignored
   *   analytics?: string | null
   *   cdn?: string = 'auto'
   *   desc?: string
   *   team?: number // ignored
   *   enabled?: boolean
   *   fancyindexing?: boolean
   *   indexfiles?: boolean
   *   filter_mode?: FilterMode
   *   filter?: string
   *   metadata?: boolean
   *   render_html?: boolean
   *   error_path?: string
   *   autoupdate?: boolean
   *   precachedata?: boolean
   *   search?: boolean
   *   favorite?: boolean
   *   expires?: number
   *   password?: string
   *   tag_web?: boolean
   *   tag_lander?: boolean
   *   tag_cdn?: boolean
   * }
   * ```
   */
  CREATE_SERVER: () => `${T.SERVER}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/list/</strong><span style="color:black">{{ if nodeleted exists <span style="color:red">?nodeleted</span> else none}}</span></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   results: number
   *   servers: Server[]
   * }
   * ```
   * URL_PARAMETER = OPTIONAL nodeleted
   */
  SERVERS_LIST: (e) => `${T.SERVER}/list${e ? "?nodeleted" : ""}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/details/</strong>{{server}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = { server: Server }
   * ```
   * URL_PARAMETER = REQUIRES server
   */
  SERVER_DETAILS: (e) => `${T.SERVER}/details/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/details/</strong>{{server}}/{{path}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   name: string
   *   domain: string
   *   server: string
   *   storage: string
   *   type: string
   *   details: FileOrFolder
   * }
   * ```
   * URL_PARAMETER = REQUIRES server & REQUIRES path
   */
  SERVER_CONTENT: (e, t) => `${T.SERVER}/details/${e}?${t}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/update/</strong>{{server}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   name?: string
   *   storage?: string
   *   domain?: string // ignored
   *   analytics?: string | null
   *   cdn?: string
   *   desc?: string
   *   team?: number // ignored
   *   enabled?: boolean
   *   fancyindexing?: boolean
   *   indexfiles?: boolean
   *   filter_mode?: FilterMode
   *   filter?: string
   *   metadata?: boolean
   *   render_html?: boolean
   *   error_path?: string
   *   autoupdate?: boolean
   *   precachedata?: boolean
   *   search?: boolean
   *   favorite?: boolean
   *   expires?: number
   *   password?: string
   *   tag_web?: boolean
   *   tag_lander?: boolean
   *   tag_cdn?: boolean
   * }
   * ```
   * URL_PARAMETER = REQUIRES server
   */
  UPDATE_SERVER: (e) => `${T.SERVER}/update/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/disable_all</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   two_factor_token?: string | number | undefined;
   * }
   * ```
   */
  DISABLE_ALL_SERVER: () => `${T.SERVER}/disable_all`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/</strong>{{server}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   two_factor_token?: string | number | undefined;
   * }
   * ```
   * URL_PARAMETER = REQUIRES server
   */
  DELETE_SERVER: (e) => `${T.SERVER}/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/undelete/</strong>{{server}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   *
   * URL_PARAMETER = REQUIRES server
   */
  UNDELETE_SERVER: (e) => `${T.SERVER}/undelete/${e}`
}, ha = ({ server: e }) => m(te.CHECK_SERVER_NAME(e)), Ta = ({ filter: e }) => j(te.VALIDATE_FILTER(), { filter: e }), Ma = ({
  cdn: e = "auto",
  analytics: t = null,
  ...n
}) => j(te.CREATE_SERVER(), { cdn: e, analytics: t, ...n }), Da = async ({ nodeleted: e } = {}) => {
  const t = await m(te.SERVERS_LIST(e));
  return t.servers.forEach(W), t;
}, Ia = async ({ server: e }) => {
  const t = await m(te.SERVER_DETAILS(e));
  return W(t.server), t;
}, We = ({
  server: e,
  path: t
}) => m(te.SERVER_CONTENT(e, t)), ma = ({
  server: e,
  ...t
}) => j(te.UPDATE_SERVER(e), t), ua = (e) => j(te.DISABLE_ALL_SERVER(), e), ja = ({
  server: e,
  two_factor_token: t
}) => V(te.DELETE_SERVER(e), { two_factor_token: t }), ga = ({ server: e }) => j(te.UNDELETE_SERVER(e)), Na = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  checkServerName: ha,
  createServer: Ma,
  deleteServer: ja,
  disableAllServers: ua,
  listServers: Da,
  serverContent: We,
  serverDetails: Ia,
  unDeleteServer: ga,
  updateServer: ma,
  validateFilter: Ta
}, Symbol.toStringTag, { value: "Module" })), Ca = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/server/list/</strong>{{server}}/{{path}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   results: number
   *   name: string
   *   domain: string
   *   server: string
   *   storage: string
   *   path: string
   *   cached: Date | null
   *   list: FileOrFolderWithType[]
   * }
   * ```
   * URL_PARAMETER = REQUIRES server & REQUIRES path
   */
  FOLDER_LIST: (e, t) => `${T.FILE_FOLDER}/${e}?${t}`
}, ya = We, Ra = async ({
  server: e,
  path: t
}) => {
  const n = await m(Ca.FOLDER_LIST(e, t));
  return n.list.forEach((a) => {
    a.modified = J(a.modified), a.cached = J(a.cached);
  }), n;
}, Ea = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  folderList: Ra,
  pathDetails: ya
}, Symbol.toStringTag, { value: "Module" })), Oa = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/log/</strong>{{server}}?end={{end}}&format={{format}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   results: number
   *   records: Log[]
   * }
   * ```
   * URL_PARAMETER = REQUIRES server & REQUIRES start & OPTIONAL end & OPTIONAL format
   */
  RETRIEVE_LOGS: (e) => `${T.LOG}/${e}`
}, Ka = async ({
  server: e,
  start: t,
  end: n,
  format: a
}) => {
  const h = await m(
    Q(Oa.RETRIEVE_LOGS(e), {
      start: typeof t == "string" ? t : t.toISOString(),
      end: typeof n == "string" ? n : n == null ? void 0 : n.toISOString(),
      format: a
    })
  );
  return h.records.forEach((D) => {
    D.transfer_start = J(D.transfer_start);
  }), h;
}, ba = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  logsRetrieve: Ka
}, Symbol.toStringTag, { value: "Module" })), Se = {
  // DON'T EXIST
  TEMPLATE: (e) => `${T.METADATA}/template/${e}`,
  // DON'T EXIST
  METADATA: (e) => `${T.METADATA}/${e}`
}, ra = ({ name: e }) => m(Se.TEMPLATE(e)), Xa = async ({
  template: e,
  ...t
}) => {
  const n = await m(Q(Se.METADATA(e), t));
  return n.metadata = JSON.parse(n.metadata), W(n), n;
}, xa = ({
  template: e,
  metadata: t,
  ...n
}) => j(Se.METADATA(e), {
  metadata: JSON.stringify(t),
  ...n
}), La = ({
  template: e,
  ...t
}) => V(Q(Se.METADATA(e), t)), _a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ENDPOINTS: Se,
  deleteMetadata: La,
  getMetadata: Xa,
  getTemplate: ra,
  setMetadata: xa
}, Symbol.toStringTag, { value: "Module" })), Z = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/org</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *  payment_token: string
   *  domain: string
   *  name: string
   *  perm_join: string
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *  result: boolean
   * }
   * ```
   */
  CREATE: () => `${T.ORGANIZATION}/create`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/details</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *  domain: string,
   *  id: number,
   *  parent: number,
   *  created: string,
   *  updated: string,
   *   name: string,
   *   description: string,
   *   logo: string,
   *   accent_color: {
   *       color: string,
   *       opacity: number
   *   },
   *   facebook: string,
   *   twitter: string,
   *   youtube: string,
   *   instagram: string,
   *   homepage: string,
   *   perm_join: string,
   *   perm_auth_domains: string,
   *   billing_email: string,
   *   encryption_key: string,
   *   subscriber: number,
   *   locked: boolean,
   *   suspended: boolean,
   *   closed: boolean
   * }
   * ```
   */
  DETAILS: (e) => `${T.ORGANIZATION}/${e}/details`,
  PUBLIC_DETAILS: (e) => `${T.ORGANIZATION}/${e}/public/details`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/:orgDomainOrID/update</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *  domain?: string
   *  name?: string
   *  perm_join?: string
   *  payment_token?: string
   *  description?: string
   *  facebook?: string
   *  homepage?: string
   *  perm_auth_domains?: string
   *  billing_email?: string
   *  encryption_key?: string
   *  accent_color?: { color: string, opacity: number }
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *  result: boolean
   * }
   * ```
   */
  UPDATE_DETAILS: (e) => `${T.ORGANIZATION}/${e}/update`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/close/:orgDomain</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   confirm: string (this confirm should be the exact thing as the folderName)
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  CLOSE_ORGANIZATION: (e) => `${T.ORGANIZATION}/close/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/members/list/:orgDomain</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   *   results: number, // The number of the members in this organization
   *   members: Array<{
   *   id: number,
   *   type: "User",
   *   permissions: "owner" | "admin"
   *   }>
   * }
   * ```
   */
  MEMBERS_LIST: (e) => `${T.ORGANIZATION}/${e}/members/list`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/:orgDomain/members/invitations/list</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   *   results: number, // The number of the invites in this organization
   *   invitations: {
   *     id: string,
   *     inviter: string,
   *     invitee_email: string,
   *     invitee_uid: string | null,
   *     entity: {
   *       id: string,
   *       id_alt: string,
   *     },
   *     state: string,
   *     created: string,
   *   }
   * ```
   */
  INVITATIONS_LIST: (e) => `${T.ORGANIZATION}/${e}/members/invitations/list`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/members/:orgDomain/:userEmail</strong></span>
   *
   * METHOD: DELETE
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   * }
   * ```
   */
  DELETE_MEMBER: (e, t) => `${T.ORGANIZATION}/${e}/members/${t}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/:orgDomain/members/invitation/:invitationId</strong></span>
   *
   * METHOD: DELETE
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   * }
   * ```
   */
  DELETE_INVITATION: (e, t) => `${T.ORGANIZATION}/${e}/members/invitation/${t}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/:orgDomain/members/invitation/:invitationId</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   * }
   * ```
   */
  UPDATE_INVITATION: (e, t) => `${T.ORGANIZATION}/${e}/members/invitation/${t}`,
  UPDATE_ORGANIZATION_MEMBER: (e, t) => `${T.ORGANIZATION}/${e}/member/${t}/update/`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/members/:orgDomain/:userEmail</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   *   member: {
   *   child: number, // The id of the child
   *   type: "User",
   *   parent: number, // The id of the parent
   *   permissions: "owner" | "admin",
   *   invite: boolean,
   *   notify_options: "Notify me in app",
   *   created: Date,
   *   updated: Date,
   *   expires: boolean,
   *   deleted: boolean
   *   }
   * }
   * ```
   */
  MEMBER_DETAILS: (e) => `${T.USER}/${e}/details`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/orgs/check/domain/:domainName</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   * }
   * ```
   */
  CHECK_DOMAIN: (e) => `${T.ORGANIZATION}s/check/domain/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/orgs/list</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *    result: true,
   *    results: 1,
   *    orgs: Array<{
   *      child: number,
   *      type: "Org",
   *      parent: number
   *    }>
   *  }
   * ```
   */
  ORGS_LIST: () => `${T.ORGANIZATION}s/list`,
  ORG_WORKSPACE_LIST: (e) => `${T.ORGANIZATION}/${e}/list/workspaces`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/{orgDomain}/assets</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type ResponseType = {
   *    result: true,
   *  }
   * ```
   */
  ASSET: (e, t) => `${T.ORGANIZATION}/${e}/assets/${t}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/{orgDomain}/assets</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type ResponseType = {
   *    result: true,
   *  }
   * ```
   */
  MEMBER: (e, t) => `${T.ORGANIZATION}/${e}/members/${t}`,
  PROCESS_ORGANIZATION_INVITATION: (e, t, n) => `${T.ORGANIZATION}/${e}/members/join/${t}/${n}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/{orgDomain}/members</strong></span>
   *
   * METHOD: DELETE
   * ```ts
   * type ResponseType = {
   *    result: true,
   *  }
   * ```
   */
  LEAVE_MEMBERSHIP: (e) => `${T.ORGANIZATION}/${e}/member`,
  INDUSTRIES: () => `${T.ORGANIZATION}s/industries`
}, ka = (e) => m(Z.CHECK_DOMAIN(e)), va = () => m(Z.ORGS_LIST()), fa = (e) => j(Z.CREATE(), e), Fa = (e) => m(Z.DETAILS(e)), Ua = (e) => m(Z.PUBLIC_DETAILS(e)), za = (e, t) => j(Z.UPDATE_DETAILS(e), t), $a = (e) => j(Z.CLOSE_ORGANIZATION(e), { confirm: e }), Ga = (e, t, n, a) => j(Z.MEMBER(e, t), { permissions: n, message: a }), Va = (e) => m(Z.MEMBERS_LIST(e)), wa = (e) => m(Z.MEMBER_DETAILS(e)), Ha = (e) => m(Z.INVITATIONS_LIST(e)), Ya = (e, t) => V(Z.DELETE_MEMBER(e, t)), Za = (e, t) => V(Z.DELETE_INVITATION(e, t)), Aa = (e, t, n) => j(Z.UPDATE_INVITATION(e, t), { permissions: n }), pa = (e, t, n) => j(Z.UPDATE_ORGANIZATION_MEMBER(e, t), { permissions: n }), Wa = (e, t, n, a) => j(
  Z.ASSET(e, "logo"),
  n === "image" ? { title: t, type: n, image: a } : { title: t, type: n, document: a },
  { multipart: !0 }
), Ba = (e, t) => m(`${Z.ASSET(e, t)}/read`), Ja = (e, t) => V(Z.ASSET(e, t)), Qa = (e) => m(Z.ORG_WORKSPACE_LIST(e)), qa = (e, t, n) => j(
  Z.PROCESS_ORGANIZATION_INVITATION(
    e,
    t,
    n
  )
), es = (e) => V(Z.LEAVE_MEMBERSHIP(e)), ts = () => m(Z.INDUSTRIES()), ns = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addAsset: Wa,
  addMember: Ga,
  checkDomainName: ka,
  closeOrganization: $a,
  createOrganization: fa,
  deleteOrganizationInvitation: Za,
  deleteOrganizationMember: Ya,
  getAsset: Ba,
  getIndustries: ts,
  getListOfAccessibleOrganizations: va,
  getOrganizationDetails: Fa,
  getOrganizationInvitations: Ha,
  getOrganizationMemberDetails: wa,
  getOrganizationMembers: Va,
  getOrganizationPublicDetails: Ua,
  getWorkspaceList: Qa,
  leaveOrganization: es,
  processOrganizationInvitation: qa,
  removeAsset: Ja,
  updateOrganization: za,
  updateOrganizationInvitation: Aa,
  updateOrganizationMember: pa
}, Symbol.toStringTag, { value: "Module" })), as = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/system/status</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type SystemStatusResponse = {
   *  updated: string;
   *  statuses: {
   *    API: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    downloads: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    uploads: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    billing: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    storage: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    encoding: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    assets: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    cache: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *    database: {
   *      status: SystemStatus;
   *      updated_at: string;
   *    };
   *  };
   * }
   *
   * type SystemStatus =
   *  | 'operational'
   *  | 'degraded_performance'
   *  | 'partial_outage'
   *  | 'major_outage'
   *  | 'under_maintenance';
   * ```
   */
  SYSTEM_STATUS: () => `${T.PLATFORM}/status`
}, ss = () => m(as.SYSTEM_STATUS()), is = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  systemStatus: ss
}, Symbol.toStringTag, { value: "Module" })), H = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/share/:org/:workspaceName</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *  custom_name: string;
   *  expires: string;
   *  description?: string;
   *  link_1?: ShareLink;
   *  comments_enabled?: boolean;
   *  view_enabled?: boolean;
   *  downloads_enabled?: boolean;
   *  receive_enabled?: boolean;
   *  display_type: DisplayType;
   *  workspace_style?: boolean;
   *  title?: string;
   *  access_options?: URLAccessType;
   *  recipient_visibility?: RecipientVisibility;
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  CREATE_SHARE: (e) => `${T.WORKSPACE}/${e}/create/share`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/share/details/:shareName</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *  result: boolean,
   *   share: {
   *     custom_name: string,
   *     id: number,
   *     parent: number,
   *     created: string,
   *     updated: string,
   *     deleted: boolean | null,
   *     description: string,
   *     comments_enabled: boolean,
   *     view_enabled: boolean,
   *     display_type: DisplayType,
   *     workspace_style: boolean,
   *     link_1: {
   *       url: string,
   *       textcolor: string,
   *       title: string
   *     },
   *     locked: boolean,
   *     suspended: boolean,
   *     closed: boolean
   *   }
   * }
   * ```
   */
  SHARE_DETAILS: (e) => `${T.SHARE}/${e}/details`,
  PUBLIC_SHARE_DETAILS: (e) => `${T.SHARE}/${e}/public/details`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/share/update/:shareName</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *  custom_name: string,
   *  id: number,
   *  parent: number,
   *  created: string,
   *  updated: string,
   *  deleted: boolean | null,
   *  description: string,
   *  comments_enabled: boolean,
   *  view_enabled: boolean,
   *  display_type: DisplayType,
   *  workspace_style: boolean,
   *  link_1: {
   *    url: string,
   *    textcolor: string,
   *    title: string
   *  },
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *  result: boolean
   * }
   * ```
   */
  UPDATE_SHARE: (e) => `${T.SHARE}/${e}/update`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/share/close/:shareName</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   confirm: string (this confirm should be the exact thing as the folderName)
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  CLOSE_SHARE: (e) => `${T.SHARE}/${e}/close?confirm=${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/shares/check/name/:shareName</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  CHECK_SHARE_NAME: (e) => `${T.SHARES}/check/name/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/share/:ShareId/members/list</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType =
   * ```
   */
  MEMBERS_LIST: (e) => `${T.SHARE}/${e}/members/list`,
  MEMBERS_LIST_INVITATION: (e) => `${T.SHARE}/${e}/members/invitations/list`,
  SHARE_ADD_MEMBER: (e, t) => `${T.SHARE}/${e}/members/${t}`,
  SHARE_UPDATE_MEMBER: (e, t) => `${T.SHARE}/${e}/member/${t}/update/`,
  SHARE_MEMBER_DETAILS: (e, t) => `${T.SHARE}/${e}/members/details/${t}`,
  SHARE_LEAVE: (e) => `${T.SHARE}/${e}/member`,
  SHARE_DELETE_MEMBER: (e, t) => `${T.SHARE}/${e}/members/${t}`,
  SHARE_DELETE_INVITATION: (e, t) => `${T.SHARE}/${e}/members/invitation/${t}`,
  PROCESS_SHARE_INVITATION: (e, t, n) => `${T.SHARE}/${e}/members/join/${t}/${n}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/share/:shareId/storage/:parentId/list</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType =
   * ```
   */
  FILES_AND_FOLDERS: (e, t) => `${T.SHARE}/${e}/storage/${t || "root"}/list`,
  ALL_SHARES: () => `${T.SHARES}/all`,
  ALL_AVAILABLE_SHARES: () => `${T.SHARES}/available`,
  ARCHIVE_SHARE: (e) => `${T.SHARE}/${e}/archive`,
  UNARCHIVE_SHARE: (e) => `${T.SHARE}/${e}/unarchive`,
  DELETE_SHARE: (e) => `${T.SHARE}/${e}/delete?confirm=${e}`,
  ASSET: (e) => `${T.SHARE}/${e}/assets/logo`
}, ls = (e, t) => j(H.CREATE_SHARE(e), t), os = (e) => m(H.SHARE_DETAILS(e)), cs = (e) => m(H.PUBLIC_SHARE_DETAILS(e)), ds = (e, t) => j(H.UPDATE_SHARE(e), t), Ps = (e) => j(H.CLOSE_SHARE(e), { confirm: e }), Ss = (e) => m(H.CHECK_SHARE_NAME(e)), hs = (e) => m(H.MEMBERS_LIST(e)), Ts = (e) => m(
  H.MEMBERS_LIST_INVITATION(e)
), Ms = (e, t) => m(H.FILES_AND_FOLDERS(e, t)), Ds = (e, t, n, a) => j(H.SHARE_ADD_MEMBER(e, t), {
  message: a,
  permissions: n
}), Is = (e, t) => m(H.SHARE_MEMBER_DETAILS(e, t)), ms = (e) => j(H.SHARE_LEAVE(e)), us = (e, t) => V(H.SHARE_DELETE_MEMBER(e, t)), js = (e, t) => V(H.SHARE_DELETE_INVITATION(e, t)), gs = (e, t, n) => j(H.PROCESS_SHARE_INVITATION(e, t, n)), Ns = () => m(H.ALL_SHARES()), Cs = () => m(H.ALL_AVAILABLE_SHARES()), ys = (e) => j(H.ARCHIVE_SHARE(e)), Rs = (e) => j(H.UNARCHIVE_SHARE(e)), Es = (e) => V(H.DELETE_SHARE(e)), Os = (e, t, n) => j(H.SHARE_UPDATE_MEMBER(e, t), {
  permissions: n
}), Ks = (e, t) => j(H.ASSET(e), { file: t }, { multipart: !0 }), bs = (e) => m(`${H.ASSET(e)}/read`), rs = (e) => V(H.ASSET(e)), Xs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addLogoAsset: Ks,
  addShareMember: Ds,
  archiveShare: ys,
  checkShareName: Ss,
  closeShare: Ps,
  createShare: ls,
  deleteShare: Es,
  deleteShareInvitation: js,
  deleteShareMember: us,
  getAllAvailableShares: Cs,
  getAllFilesAndFolders: Ms,
  getAllShareMembers: hs,
  getAllShareMembersInvitation: Ts,
  getAllShares: Ns,
  getLogiAsset: bs,
  getPublicShareDetails: cs,
  getShareDetails: os,
  getShareMemberDetails: Is,
  leaveShare: ms,
  processShareInvitation: gs,
  removeLogoAsset: rs,
  unarchiveShare: Rs,
  updateShare: ds,
  updateShareMember: Os
}, Symbol.toStringTag, { value: "Module" }));
var Be = /* @__PURE__ */ ((e) => (e.Exchange = "exchange", e.Send = "send", e.Receive = "receive", e))(Be || {}), Je = /* @__PURE__ */ ((e) => (e.Owner = "owner", e.Guest = "guest", e.Excluded = "excluded", e.Public = "public", e))(Je || {}), Qe = /* @__PURE__ */ ((e) => (e.List = "List", e.Thumbnail = "Thumbnail", e.Gallery = "Gallery", e.Blog = "Blog", e))(Qe || {}), qe = /* @__PURE__ */ ((e) => (e.MEMBERS_ONLY = "Only members of the Share or Workspace", e.ORG_MEMBERS = "Members of the Share, Workspace or Org", e.REGISTERED_USERS = "Anyone with a registered account", e.PUBLIC = "Anyone with the link", e))(qe || {}), et = /* @__PURE__ */ ((e) => (e["Activity is visible"] = "Activity is visible", e["Activity is anonymized"] = "Activity is anonymized", e))(et || {}), tt = /* @__PURE__ */ ((e) => (e.Pending = "pending", e))(tt || {}), nt = /* @__PURE__ */ ((e) => (e.Shared = "share", e.Organization = "org", e.Workspace = "workspace", e))(nt || {}), at = /* @__PURE__ */ ((e) => (e.Accept = "accept", e.Decline = "decline", e))(at || {});
const xs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultLayout: Qe,
  InvitationActions: at,
  InvitationStatuses: tt,
  InvitationTypes: nt,
  RecipientVisibility: et,
  ShareLevel: Je,
  ShareType: Be,
  URLAccessType: qe
}, Symbol.toStringTag, { value: "Module" }));
var st = /* @__PURE__ */ ((e) => (e.THUMBNAIL = "thumbnail", e.IMAGE = "image", e.HLSSTREAM = "hlsstream", e.PDF = "pdf", e.SPREADSHEET = "spreadsheet", e))(st || {});
const w = {
  LIST: (e, t, n) => `${e}/${t}/storage/${n}/list`,
  DETAILS: (e, t, n) => `${e}/${t}/storage/${n}/details`,
  CREATE_FOLDER: (e, t, n) => `${e}/${t}/storage/${n}/createfolder`,
  ADD_FILE: (e, t, n) => `${e}/${t}/storage/${n}/addfile`,
  ADD_LINK: (e, t, n) => `${e}/${t}/storage/${n}/addlink`,
  CREATE_MARKDOWN: (e, t, n) => `${e}/${t}/storage/${n}/createnote`,
  UPDATE_MARKDOWN: (e, t, n) => `${e}/${t}/storage/${n}/updatenote`,
  UPDATE: (e, t, n) => `${e}/${t}/storage/${n}/update`,
  MOVE: (e, t, n) => `${e}/${t}/storage/${n}/move`,
  COPY: (e, t, n) => `${e}/${t}/storage/${n}/copy`,
  TRANSFER: (e, t, n) => `${e}/${t}/storage/${n}/transfer`,
  REQUEST_READ: (e, t, n) => `${e}/${t}/storage/${n}/requestread`,
  OPEN_READ: (e, t, n, a) => {
    const h = e.includes("quickshare"), D = h ? "" : `/${n}`, g = h ? "" : `?token=${a}`;
    return `${e}/${t}/storage${D}/read${g}`;
  },
  DELETE: (e, t, n) => `${e}/${t}/storage/${n}/delete`,
  SEARCH: (e, t, n) => `${e}/${t}/storage/search?search=${n}`,
  EMPTY_TRASH: (e, t) => `${e}/${t}/storage/trash/delete`,
  RESTORE_TRASH: (e, t, n) => `${e}/${t}/storage/${n}/restore`,
  GET_VERSIONS: (e, t, n) => `${e}/${t}/storage/${n}/versions`,
  GET_TRANSFORM: (e, t, n, a, h) => `${e}/${t}/storage/${n}/transform/${a}/read?${Object.entries(
    h
  ).map(([D, g]) => `${D}=${g}&`).join("")}`,
  PREVIEW: {
    READ_PRIMARY: (e, t, n, a, h) => {
      const D = e.includes("quickshare") ? "" : `/${n}`;
      return `${e}/${t}/storage${D}/preview/${a}/read${h ? `?size=${h}` : ""}`;
    },
    READ_FILE: (e, t, n, a, h, D) => e.includes("quickshare") ? `${e}/${t}/storage/preview/${a}/read/file/` : `${e}/${t}/storage/${n}/preview/${a}/read/${h}/file/${D}`,
    PREAUTHORIZE: (e, t, n, a) => `${e}/${t}/storage/${n}/preview/${a}/preauthorize`
  },
  LIST_QUICK_SHARES: (e, t) => `${e}/${t}/storage${T.QUICK_SHARES}/list`,
  CREATE_QUICK_SHARE: (e, t, n) => `${e}/${t}/storage/${n}${T.QUICK_SHARE}`,
  DELETE_QUICK_SHARE: (e, t, n) => `${e}/${t}/storage/${n}${T.QUICK_SHARE}`,
  GET_TEMPLATES: (e, t, n) => `${e}/${t}/storage/${n}/metadata/templates`,
  GET_METADATA_LIST: (e, t, n, a, h) => {
    let D = `${e}/${t}/storage/${n}/metadata/list/${a}`;
    if (h) {
      const g = new URLSearchParams();
      h.filters && g.append("filters", h.filters), h.order_by && g.append("order_by", h.order_by), h.order_desc !== void 0 && g.append("order_desc", h.order_desc.toString());
      const C = g.toString();
      C && (D += `?${C}`);
    }
    return D;
  }
}, it = (e, t) => {
  const n = e === "workspace" ? T.WORKSPACE : e === "quickshare" ? T.QUICK_SHARE : T.SHARE;
  return {
    getList: (a) => m(w.LIST(n, t, a)),
    getDetails: (a) => m(
      w.DETAILS(n, t, a)
    ),
    createFolder: (a, h) => j(
      w.CREATE_FOLDER(n, t, a),
      { name: h }
    ),
    addFile: (a, h, D) => j(
      w.ADD_FILE(n, t, a),
      { name: h, from: D }
    ),
    addLink: (a, h, D) => j(
      w.ADD_LINK(n, t, a),
      { type: h, share: D }
    ),
    update: (a, h, D) => j(
      w.UPDATE(n, t, a),
      { name: h, from: D }
    ),
    createMarkdown: (a, h, D) => j(
      w.CREATE_MARKDOWN(n, t, a),
      { name: h, content: D }
    ),
    updateMarkdown: (a, h, D) => j(
      w.UPDATE_MARKDOWN(n, t, a),
      { name: h, content: D }
    ),
    move: (a, h) => j(w.MOVE(n, t, a), { parent: h }),
    copy: (a, h) => j(
      w.COPY(n, t, a),
      { parent: h }
    ),
    transfer: (a, h, D) => j(
      w.TRANSFER(n, t, a),
      { parent: D, instance: h }
    ),
    readRequest: (a) => m(
      w.REQUEST_READ(n, t, a),
      {
        includeCredentials: !0
      }
    ),
    readOpen: (a, h) => be(w.OPEN_READ(n, t, a, h)),
    search: (a) => m(
      w.SEARCH(n, t, a)
    ),
    delete: (a) => V(
      w.DELETE(n, t, a)
    ),
    emptyTrash: () => V(w.EMPTY_TRASH(n, t)),
    restoreTrash: (a) => j(
      w.RESTORE_TRASH(n, t, a)
    ),
    getTransform: (a, h, D) => m(
      w.GET_TRANSFORM(
        n,
        t,
        a,
        h,
        D
      )
    ),
    getVersions: (a) => m(
      w.GET_VERSIONS(n, t, a)
    ),
    preview: (a) => ({
      readPrimary: (h, D) => m(
        w.PREVIEW.READ_PRIMARY(
          n,
          t,
          a,
          h,
          D
        )
      ),
      readFile: (h, D, g) => m(
        w.PREVIEW.READ_FILE(
          n,
          t,
          a,
          h,
          D,
          g
        )
      ),
      preauthorize: (h) => n === T.QUICK_SHARE ? {
        result: !0,
        downloadToken: void 0,
        primaryFilename: void 0,
        path: h === st.HLSSTREAM ? `${Ye(
          `${n}/${t}/storage/preview/${h}/read/file/video.m3u8`
        )}` : void 0
      } : m(
        w.PREVIEW.PREAUTHORIZE(n, t, a, h)
      )
    }),
    getQuickShares: () => m(
      w.LIST_QUICK_SHARES(n, t)
    ),
    createQuickShare: (a, h) => j(
      w.CREATE_QUICK_SHARE(n, t, a),
      { expires: h }
    ),
    deleteQuickShare: (a) => V(w.DELETE_QUICK_SHARE(n, t, a)),
    getTemplates: (a) => m(
      w.GET_TEMPLATES(n, t, a)
    ),
    getMetadataList: (a, h, D) => m(
      w.GET_METADATA_LIST(
        n,
        t,
        a,
        h,
        D
      )
    )
  };
}, Ls = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  init: it
}, Symbol.toStringTag, { value: "Module" })), oe = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/2factor/auth/</strong>{{token}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type ResponseType = {
   *   expires_in: number
   *   auth_token: string
   * }
   * ```
   * URL_PARAMETER = REQUIRES token
   */
  AUTH: (e) => `${T.TWO_FACTOR}/auth/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/2factor</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   state: 'disabled' | 'enabled' | 'unverified'
   * }
   * ```
   */
  ENABLE: () => `${T.TWO_FACTOR}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/2factor/verify/</strong>{{token}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   *
   * URL_PARAMETER = REQUIRES token
   */
  VERIFY: (e) => `${T.TWO_FACTOR}/verify/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/2factor</strong>{{token}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: DELETE
   *
   * URL_PARAMETER = REQUIRES token
   */
  REMOVE: (e) => `${T.TWO_FACTOR}/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/2factor/call</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   */
  SEND_CALL: () => `${T.TWO_FACTOR}/call`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/2factor/code</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   */
  SEND_CODE: () => `${T.TWO_FACTOR}/code`
}, _s = ({ token: e }) => j(oe.AUTH(e)), ks = () => j(oe.ENABLE()), vs = ({ token: e }) => j(oe.VERIFY(e)), fs = () => m(oe.ENABLE()), Fs = ({ token: e }) => V(oe.REMOVE(e)), Us = () => m(oe.SEND_CALL()), zs = () => m(oe.SEND_CODE()), $s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  auth2Factor: _s,
  enable2Factor: ks,
  get2Factor: fs,
  remove2Factor: Fs,
  send2FactorCall: Us,
  send2FactorCode: zs,
  verify2Factor: vs
}, Symbol.toStringTag, { value: "Module" })), se = {
  CREATE_UPLOAD_SESSION: () => `${T.UPLOAD}`,
  GET_SESSIONS: () => `${T.UPLOAD}/details`,
  GET_UPLOAD_SESSION: (e, t) => `${T.UPLOAD}/${e}/details?wait=${t}`,
  UPLOAD_CHUNKS: (e) => `${T.UPLOAD}/${e}/chunk`,
  UPLOAD_ASSEMBLE: (e) => `${T.UPLOAD}/${e}/complete`,
  DELETE_UPLOAD_SESSION: (e) => `${T.UPLOAD}/${e}`,
  DELETE_UPLOAD_CHUNK: (e, t) => `${T.UPLOAD}/chunk/${e}?order=${t}`,
  GET_HASH_ALGORITHM: () => `${T.UPLOAD}/algos`
}, lt = (e) => j(se.CREATE_UPLOAD_SESSION(), e), ot = async () => m(se.GET_SESSIONS()), Gs = async ({
  id: e,
  wait: t
}) => m(se.GET_UPLOAD_SESSION(e, t)), Vs = ({ id: e }) => m(se.UPLOAD_CHUNKS(e)), ct = ({
  id: e,
  name: t,
  hash: n,
  size: a,
  chunk: h,
  order: D,
  hash_algo: g,
  customXHR: C,
  onProgress: u
}) => j(
  se.UPLOAD_CHUNKS(e),
  { size: a, chunk: h, order: D, hash: n, hash_algo: g },
  { onProgress: u, multipart: !0, filename: t },
  void 0,
  C
), ws = ({ id: e }) => j(se.UPLOAD_ASSEMBLE(e)), re = ({ id: e }) => V(se.DELETE_UPLOAD_SESSION(e)), Hs = ({ id: e, order: t }) => V(se.DELETE_UPLOAD_CHUNK(e, t)), Ys = () => m(se.GET_HASH_ALGORITHM()), Zs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createUploadSession: lt,
  deleteChunk: Hs,
  deleteUploadSession: re,
  getHashAlgos: Ys,
  getUploadChunks: Vs,
  getUploadSession: Gs,
  getUploadSessions: ot,
  uploadAssemble: ws,
  uploadChunk: ct
}, Symbol.toStringTag, { value: "Module" })), ge = async (e) => {
  const t = await e;
  return t.transfers.forEach((a) => {
    typeof a.transfers == "string" && (a.transfers = Number.parseInt(a.transfers)), typeof a.bytes == "string" && (a.bytes = Number.parseInt(a.bytes)), a.start = J(a.start), a.end = J(a.end);
  }), t;
}, Ne = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/stats</strong>?end={{end}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   results: number
   *   interval: number
   *   transfers: Transfer[]
   * }
   * ```
   * URL_PARAMETER = REQUIRES start & OPTIONAL end
   */
  ACCOUNT_STATISTICS: () => `${T.STATISTICS}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/stats/recent</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   results: number
   *   interval: number
   *   transfers: Transfer[]
   * }
   * ```
   */
  RECENT_ACCOUNT_STATISTICS: () => `${T.STATISTICS}/recent`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/stats/server/</strong>{{server}}?end={{end}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   server: string
   *   results: number
   *   interval: number
   *   transfers: Transfer[]
   * }
   * ```
   * URL_PARAMETER = REQUIRES server & REQUIRES start & OPTIONAL end
   */
  SERVER_STATISTICS: (e) => `${T.STATISTICS}/server/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/stats/server/recent/</strong>{{server}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   server: string
   *   results: number
   *   interval: number
   *   transfers: Transfer[]
   * }
   * ```
   * URL_PARAMETER = REQUIRES server
   */
  RECENT_SERVER_STATISTICS: (e) => `${T.STATISTICS}/server/recent/${e}`
}, As = (e) => ge(
  m(Q(Ne.ACCOUNT_STATISTICS(), e))
), ps = () => ge(m(Ne.RECENT_ACCOUNT_STATISTICS())), Ws = ({
  server: e,
  ...t
}) => ge(
  m(
    Q(Ne.SERVER_STATISTICS(e), t)
  )
), Bs = ({ server: e }) => ge(
  m(Ne.RECENT_SERVER_STATISTICS(e))
), Js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accountStats: As,
  accountStatsRecent: ps,
  serverStats: Ws,
  serverStatsRecent: Bs
}, Symbol.toStringTag, { value: "Module" })), A = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/user</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   email_address: string
   *   password: string
   *   tos_agree: boolean
   *   first_name: string
   *   last_name: string
   *   country_code: string
   *   phone_number?: string
   * }
   * ```
   *
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  CREATE_USER: () => `${T.USER}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/details</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = { user: User }
   * ```
   */
  USER_DETAILS: () => `${T.USER}/me/details`,
  USER_DETAILS_WITH_ID: (e) => `${T.USER}/${e}/details`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/update</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type ResponseType = {
   *   email_address?: string
   *   password?: string
   *   first_name?: string
   *   last_name?: string
   *   phone_country?: number
   *   phone_number?: number
   *   autoupgrade?: boolean
   * }
   * ```
   */
  UPDATE_USER: () => `${T.USER}/update`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/email/validate/</strong><span style="color:black">{{if email exists <span style="color:red">email_address</span> else none}}</span></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   email: string,
   *   email_token: string,
   * }
   * ```
   */
  VALIDATE_EMAIL: () => `${T.USER}/email/validate`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/email/</strong>{{email_address}}</span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   email: string,
   *   email_token: string,
   * }
   * ```
   */
  CHECK_EMAIL: () => `${T.USER}/email`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/phone/</strong>{{phone_country}}-{{phone_number}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   *
   * URL_PARAMETER = REQUIRES phone_country & REQUIRES phone_number
   */
  CHECK_PHONE: (e, t) => `${T.USER}/phone/${e}-${t}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/password/email/</strong>{{code}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = { email: string }
   * ```
   * URL_PARAMETER = REQUIRES code
   */
  CHECK_PASSWORD_CODE: (e) => `${T.USER}/password/email/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/password/</strong>{{code}}</span>
   *
   * REQUIRES AUTH
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   password1: string,
   *   password2: string,
   * }
   * ```
   * URL_PARAMETER = REQUIRES code
   */
  SET_PASSWORD: (e) => `${T.USER}/password/${e}`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/email/reset</strong>{{email_address}}</span>
   *
   * METHOD: GET
   *
   * URL_PARAMETER = REQUIRES email_address
   */
  LOST_PASSWORD: () => `${T.USER}/email/reset`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/close</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = { email_address: string }
   * ```
   */
  CLOSE_ACCOUNT: () => `${T.USER}/close`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/auth</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = { id: number; scope: string }
   * ```
   */
  CHECK_AUTH: () => `${T.USER}/auth`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/user/pin</strong></span>
   *
   * REQUIRES AUTH
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = { supportcode: string; intercom: string }
   * ```
   */
  SUPPORT_PIN: () => `${T.USER}/pin`,
  /**
   * SIGNUP
   * ENDPOINT: <span style="color:red"><strong>/user</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   * first_name: string,
   * last_name: string
   * password: string
   * email_address: string
   * tos_agree: boolean
   * country_code: string
   * phone_number: string
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  // SIGNUP: () => `/${NAME_SPACES.AUTH_WITH_EMAIL}`
  /**
   * ASSET
   * ENDPOINT: <span style="color:red"><strong>/user/{userId}/assets/profile_photo</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  ASSET: (e) => `${T.USER}/${e}/assets/profile_photo`,
  GET_INVITATION_DETAILS: (e) => `${T.USER}/invitation/${e}/public/details`,
  PASSWORD_CODE_DETAILS: (e) => `${T.USER}/password/details/${e}`,
  AVAILABLE_PROFILES: () => `${T.USER}/available_profiles`,
  ACCEPT_ALL_INVITATIONS: (e) => `${T.USER}/invitations/acceptall/?invitation_key=${e}`
}, Qs = async (e) => j(A.CREATE_USER(), e), qs = async () => {
  const e = await m(A.USER_DETAILS());
  return W(e.user), e;
}, ei = (e) => m(A.USER_DETAILS_WITH_ID(e)), ti = (e) => j(A.UPDATE_USER(), e), ni = (e) => j(A.VALIDATE_EMAIL(), { email: e }), ai = ({
  email: e,
  email_token: t
}) => j(A.VALIDATE_EMAIL(), { email: e, email_token: t }), si = ({ email_address: e }) => j(A.CHECK_EMAIL(), { email_address: e }), ii = ({
  phone_country: e,
  phone_number: t
}) => m(A.CHECK_PHONE(e, t)), li = ({ code: e }) => m(A.CHECK_PASSWORD_CODE(e)), oi = ({
  code: e,
  password1: t,
  password2: n
}) => j(A.SET_PASSWORD(e), { password1: t, password2: n }), ci = ({ email: e }) => j(A.LOST_PASSWORD(), { email: e }), di = ({ email_address: e }) => j(A.CLOSE_ACCOUNT(), { email_address: e }), Pi = () => m(A.CHECK_AUTH()), Si = () => m(A.SUPPORT_PIN()), hi = (e, t) => j(A.ASSET(e), { file: t }, { multipart: !0 }), Ti = (e) => m(`${A.ASSET(e)}/read`), Mi = (e) => V(A.ASSET(e)), Di = (e) => m(
  A.GET_INVITATION_DETAILS(e)
), Ii = (e) => m(A.PASSWORD_CODE_DETAILS(e)), mi = () => m(A.AVAILABLE_PROFILES()), ui = (e) => j(A.ACCEPT_ALL_INVITATIONS(e)), ji = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  acceptAllInvitations: ui,
  addProfilePhoto: hi,
  authorizationCheck: Pi,
  checkEmail: si,
  checkPasswordCode: li,
  checkPhone: ii,
  closeAccount: di,
  createUser: Qs,
  getAvailableProfiles: mi,
  getInvitationDetails: Di,
  getPasswordCodeDetails: Ii,
  getProfilePhoto: Ti,
  getUserDetailsById: ei,
  lostPassword: ci,
  removeProfilePhoto: Mi,
  sendValidationEmail: ni,
  setPassword: oi,
  supportPin: Si,
  updateUserDetails: ti,
  userDetails: qs,
  validateEmail: ai
}, Symbol.toStringTag, { value: "Module" })), gi = {
  SEARCH: () => `${T.USERS}/search`
}, Ni = (e) => m(Q(gi.SEARCH(), e)), Ci = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  search: Ni
}, Symbol.toStringTag, { value: "Module" })), Y = {
  /**
   * ENDPOINT: <span style="color:red"><strong>/workspace/:org</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   folder_name: string
   *   name: string
   *   description?: string
   *   accent_color?: { color: string, opacity: number }
   *   perm_join?: string
   *   perm_guests?: string
   *   perm_visibility?: string
   * }
   * ```
   *
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  WORKSPACE_CREATE: (e) => `${T.ORGANIZATION}/${e}/create/workspace`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/workspace/details/:org/:folder_name</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   folder_name: string
   *   name: string
   *   description?: string
   *   accent_color?: { color: string, opacity: number }
   *   perm_join?: string
   *   perm_guests?: string
   *   perm_visibility?: string
   * }
   * ```
   */
  WORKSPACE_DETAILS: (e) => `${T.WORKSPACE}/${e}/details`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/workspace/update/:org/:folder_name</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   folder_name?: string;
   *   name?: string;
   *   description?: string;
   *   accent_color?: { color: string; opacity: number };
   *   perm_join?: string;
   *   perm_guests?: string;
   *   perm_visibility?: string;
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  WORKSPACE_UPDATE: (e) => `${T.WORKSPACE}/${e}/update`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/workspace/close/:org/:folder_name</strong></span>
   *
   * METHOD: POST
   * ```ts
   * type BodyType = {
   *   confirm: string (this confirm should be the exact thing as the folderName)
   * }
   * ```
   * ```ts
   * type ResponseType = {
   *   result: boolean
   * }
   * ```
   */
  WORKSPACE_ARCHIVE: (e) => `${T.WORKSPACE}/${e}/archive`,
  WORKSPACE_UNARCHIVE: (e) => `${T.WORKSPACE}/${e}/unarchive`,
  WORKSPACE_DELETE: (e) => `${T.WORKSPACE}/${e}/delete?confirm=${e}`,
  WORKSPACE_MEMBERS_LIST: (e) => `${T.WORKSPACE}/${e}/members/list`,
  WORKSPACE_INVITATIONS_LIST: (e) => `${T.WORKSPACE}/${e}/members/invitations/list`,
  WORKSPACE_INVITATIONS_DELETE: (e, t) => `${T.WORKSPACE}/${e}/members/invitation/${t}`,
  WORKSPACE_ADD_MEMBER: (e, t) => `${T.WORKSPACE}/${e}/members/${t}`,
  WORKSPACE_UPDATE_MEMBER: (e, t) => `${T.WORKSPACE}/${e}/member/${t}/update`,
  WORKSPACE_DELETE_MEMBER: (e, t) => `${T.WORKSPACE}/${e}/members/${t}`,
  WORKSPACE_LEAVE: (e) => `${T.WORKSPACE}/${e}/member/`,
  WORKSPACE_JOIN_MEMBER: (e) => `${T.WORKSPACE}/${e}/members/join/`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/list/workspaces/:org</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   *   results: number, // The number of workspaces that this organization have
   *   workspaces: Array<{
   *     child: number, // The id of the child
   *     type: "Workspace",
   *     parent: number, // The if of the parent
   *     permissions: number,
   *     created: Date,
   *     updated: Date,
   *     expires: boolean,
   *     deleted: boolean
   *     }>
   * }
   * ```
   */
  WORKSPACE_LIST_ALL: () => `${T.WORKSPACES}/all`,
  /**
   * ENDPOINT: <span style="color:red"><strong>/org/list/workspaces/:org</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   *   results: number, // The number of workspaces that this organization have
   *   workspaces: Array<{
   *     child: number, // The id of the child
   *     type: "Workspace",
   *     parent: number, // The if of the parent
   *     permissions: number,
   *     created: Date,
   *     updated: Date,
   *     expires: boolean,
   *     deleted: boolean
   *     }>
   * }
   * ```
   */
  WORKSPACE_LIST_AVAILABLE: () => `${T.WORKSPACES}/all`,
  WORKSPACE_SHARES_LIST: (e, t) => `${T.WORKSPACE}/${e}/list/shares?archived=${t}`,
  /**
  /**
   * ENDPOINT: <span style="color:red"><strong>/workspace/:workspaceFolderName/metadata/templates/list</strong></span>
   *
   * METHOD: GET
   * ```ts
   * type ResponseType = {
   *   result: boolean,
   *   count: number,
   *   items: Array<{
   *     id: string,
   *     system_template: boolean,
   *     instanceId: string | null
   *   }>
   * }
   * ```
   */
  WORKSPACE_METADATA_TEMPLATES: (e) => `${T.WORKSPACE}/${e}/metadata/templates/list/all`,
  WORKSPACE_METADATA_TEMPLATE: (e, t) => `${T.WORKSPACE}/${e}/metadata/templates/${t}/details`,
  PROCESS_WORKSPACE_INVITATION: (e, t, n) => `${T.WORKSPACE}/${e}/members/join/${t}/${n}`,
  GET_QUICK_SHARE: (e) => `${T.QUICK_SHARE}/${e}/details`,
  ASSET: (e) => `${T.WORKSPACE}/${e}/assets/logo`
}, yi = (e, t) => j(Y.WORKSPACE_CREATE(e), t), Ri = (e) => m(Y.WORKSPACE_DETAILS(e)), Ei = () => m(Y.WORKSPACE_LIST_ALL()), Oi = () => m(Y.WORKSPACE_LIST_AVAILABLE()), Ki = (e, t) => j(Y.WORKSPACE_UPDATE(e), t), bi = (e) => j(Y.WORKSPACE_ARCHIVE(e)), ri = (e) => j(Y.WORKSPACE_UNARCHIVE(e)), Xi = (e) => V(Y.WORKSPACE_DELETE(e)), xi = (e) => m(Y.WORKSPACE_MEMBERS_LIST(e)), Li = (e) => m(
  Y.WORKSPACE_INVITATIONS_LIST(e)
), _i = (e, t) => V(Y.WORKSPACE_INVITATIONS_DELETE(e, t)), ki = (e, t, n, a) => j(Y.WORKSPACE_ADD_MEMBER(e, t), {
  permissions: n,
  message: a
}), vi = (e, t, n) => j(Y.WORKSPACE_UPDATE_MEMBER(e, t), {
  permissions: n
}), fi = (e, t) => V(Y.WORKSPACE_DELETE_MEMBER(e, t)), Fi = (e) => V(Y.WORKSPACE_LEAVE(e)), Ui = (e) => j(Y.WORKSPACE_JOIN_MEMBER(e)), zi = (e, t) => m(
  Y.WORKSPACE_SHARES_LIST(e, t)
), $i = (e) => m(
  Y.WORKSPACE_METADATA_TEMPLATES(e)
), Gi = (e, t) => m(
  Y.WORKSPACE_METADATA_TEMPLATE(e, t)
), Vi = (e, t, n) => j(
  Y.PROCESS_WORKSPACE_INVITATION(
    e,
    t,
    n
  )
), wi = (e) => m(Y.GET_QUICK_SHARE(e)), Hi = (e, t) => j(Y.ASSET(e), { file: t }, { multipart: !0 }), Yi = (e) => m(`${Y.ASSET(e)}/read`), Zi = (e) => V(Y.ASSET(e)), Ai = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addLogoAsset: Hi,
  addMember: ki,
  archiveWorkspace: bi,
  createWorkspace: yi,
  deleteMember: fi,
  deleteWorkspace: Xi,
  deleteWorkspaceInvitation: _i,
  getLogoAsset: Yi,
  getQuickShare: wi,
  getWorkspaceDetails: Ri,
  getWorkspaceInvitations: Li,
  getWorkspaceListAll: Ei,
  getWorkspaceListAvailable: Oi,
  getWorkspaceMembers: xi,
  getWorkspaceMetadataTemplate: Gi,
  getWorkspaceMetadataTemplates: $i,
  getWorkspaceSharesList: zi,
  joinMember: Ui,
  leaveWorkspace: Fi,
  processWorkspaceInvitation: Vi,
  removeLogoAsset: Zi,
  unarchiveWorkspace: ri,
  updateMember: vi,
  updateWorkspace: Ki
}, Symbol.toStringTag, { value: "Module" })), ce = {
  CHAT_LIST: (e, t) => `/${e}/${t}/ai/chat/list`,
  CHAT_DETAIL: (e, t, n) => `/${e}/${t}/ai/chat/${n}/details`,
  CHAT_MESSAGES: (e, t, n) => `/${e}/${t}/ai/chat/${n}/messages/list`,
  CHAT_DELETE: (e, t, n) => `/${e}/${t}/ai/chat/${n}`,
  CREATE_CHAT_MESSAGE: (e, t, n) => `/${e}/${t}/ai/chat/${n}/message`,
  CREATE_CHAT: (e, t) => `/${e}/${t}/ai/chat`,
  UPDATE_CHAT: (e, t, n) => `/${e}/${t}/ai/chat/${n}/update`,
  PUBLISH_CHAT: (e, t, n) => `/${e}/${t}/ai/chat/${n}/publish`
}, pi = (e, t) => m(ce.CHAT_LIST(e, t)), Wi = (e, t, n) => m(
  ce.CHAT_DETAIL(e, t, n)
), Bi = (e, t, n, a) => j(
  ce.UPDATE_CHAT(e, t, n),
  {
    name: a
  }
), Ji = (e, t, n) => j(
  ce.PUBLISH_CHAT(e, t, n)
), Qi = (e, t, n) => V(
  ce.CHAT_DELETE(e, t, n)
), qi = (e, t, n, a, h, D, g, C) => j(
  ce.CREATE_CHAT_MESSAGE(e, t, n),
  {
    question: a,
    personality: h,
    ...!!D && { files_scope: D },
    ...!!g && { folders_scope: g },
    ...!!C && { files_attach: C }
  }
), el = (e, t, n, a, h, D, g, C, u) => j(ce.CREATE_CHAT(e, t), {
  type: n,
  question: a,
  privacy: h ? "private" : "public",
  personality: D,
  ...!!g && { files_scope: g },
  ...!!C && { folders_scope: C },
  ...!!u && { files_attach: u }
}), tl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createChatMessage: qi,
  createNewChat: el,
  deleteChat: Qi,
  getChatDetail: Wi,
  getChatList: pi,
  publishChat: Ji,
  updateChat: Bi
}, Symbol.toStringTag, { value: "Module" })), xl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  activity: Wt,
  alertsAndEvents: tn,
  analytics: Sn,
  appIntegrations: Cn,
  assets: Kn,
  auth: Hn,
  billing: ea,
  cdn: aa,
  common: Zt,
  domainBindings: ca,
  events: Sa,
  filesAndFolders: Ea,
  logs: ba,
  metadata: _a,
  organization: ns,
  platform: is,
  server: Na,
  share: Xs,
  shareTypes: xs,
  storage: Ls,
  twoFactor: $s,
  upload: Zs,
  usageStatistics: Js,
  user: ji,
  users: Ci,
  workspace: Ai,
  workspaceAichat: tl
}, Symbol.toStringTag, { value: "Module" })), nl = (e) => {
  const t = new URLSearchParams(e), { prompt: n, state: a, code: h, scope: D, authuser: g, hd: C } = Object.fromEntries(
    t.entries()
  );
  return {
    prompt: n,
    state: a,
    code: h,
    scope: D,
    authuser: g,
    hd: C
  };
}, al = (e) => {
  const t = new URLSearchParams(e), { response_type: n, client_id: a, state: h, redirect_uri: D, access_type: g, scope: C } = Object.fromEntries(t.entries());
  return {
    response_type: n,
    client_id: a,
    state: h,
    redirect_uri: D,
    access_type: g,
    scope: C
  };
}, Ll = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SSORedirectURLToObject: al,
  URLToObject: nl
}, Symbol.toStringTag, { value: "Module" }));
var p = /* @__PURE__ */ ((e) => (e.Ready = "ready", e.Uploading = "uploading", e.Assemble = "assemble", e.Assembling = "assembling", e.AssemblyFailed = "assembly_failed", e.Complete = "complete", e.Store = "store", e.Storing = "storing", e.Stored = "stored", e.StoreFailed = "store_failed", e))(p || {}), G = /* @__PURE__ */ ((e) => (e.Queued = "queued", e.Paused = "paused", e.Aborted = "aborted", e.Failed = "failed", e.Hashing = "hashing", e.HashFailed = "hash_failed", e.Ready = "ready", e.Uploading = "uploading", e.Assembling = "assembling", e.Assemble = "assemble", e.AssemblyFailed = "assembly_failed", e.Complete = "complete", e.Store = "store", e.Storing = "storing", e.Stored = "stored", e.StoreFailed = "store_failed", e.Deleting = "deleting", e))(G || {});
function sl(e, t = 100) {
  if (e.length <= t)
    return e;
  const n = e.lastIndexOf("."), a = e.slice(0, n), h = e.slice(n + 1);
  return `${a.slice(0, t - h.length - 1)}.${h}`;
}
function il(e) {
  return new Promise((t) => setTimeout(t, e));
}
function ll() {
  try {
    const t = crypto.getRandomValues(new Int32Array(1)).buffer;
    return new DataView(t).getUint32(0);
  } catch {
    return Math.random();
  }
}
function ve() {
  try {
    return crypto.randomUUID();
  } catch {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
      const n = ll() * 16 | 0;
      return (t === "x" ? n : n & 3 | 8).toString(16);
    });
  }
}
function fe(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) {
    const a = (e[n] & 255).toString(16);
    a.length < 2 && (t += "0"), t += a;
  }
  return t;
}
function ol(e, t, n) {
  if (typeof e.arrayBuffer == "function")
    e.arrayBuffer().then(t).catch(n);
  else {
    const a = new FileReader();
    a.onload = () => t(a.result), a.onerror = () => n(a.error), a.onabort = () => n(a.error), a.readAsArrayBuffer(e);
  }
}
function cl(e, t) {
  const n = e ? e.byteLength : t || 65536;
  if (n & 4095 || n <= 0)
    throw new Error(
      "heap size must be a positive integer and a multiple of 4096"
    );
  return e = e || new Uint8Array(new ArrayBuffer(n)), e;
}
function dl(e, t, n, a, h) {
  const D = e.length - t, g = D < h ? D : h;
  return e.set(n.subarray(a, a + g), t), g;
}
function dt(e, t, n) {
  const a = n || { leading: !1, trailing: !1 };
  let h, D, g, C = null, u = 0;
  const $ = () => {
    u = a.leading === !1 ? 0 : Date.now(), C = null, g = e.apply(h, D), C || (h = D = null);
  };
  return function() {
    const K = Date.now();
    !u && a.leading === !1 && (u = K);
    const _ = t - (K - u);
    return h = this, D = arguments, _ <= 0 || _ > t ? (C && (clearTimeout(C), C = null), u = K, g = e.apply(h, D), C || (h = D = null)) : !C && a.trailing !== !1 && (C = setTimeout($, _)), g;
  };
}
const Xe = 1024 * 1024, Pl = 3e3, Sl = 3, hl = 8, Tl = Xe * 1e3, Ml = Xe * 50, Dl = Xe * 1, Il = 5, ml = 10, Pt = "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", Fe = typeof window < "u" && window.Blob && new Blob([atob(Pt)], { type: "text/javascript;charset=utf-8" });
function ul() {
  let e;
  try {
    if (e = Fe && (window.URL || window.webkitURL).createObjectURL(Fe), !e)
      throw "";
    return new Worker(e);
  } catch {
    return new Worker("data:application/javascript;base64," + Pt);
  } finally {
    e && (window.URL || window.webkitURL).revokeObjectURL(e);
  }
}
var jl = function(e, t) {
  var n = 0, a = 0, h = 0, D = 0, g = 0, C = 0, u = 0, $ = 0, K = 0, _ = 0, I = new e.Uint8Array(t);
  function B(M, N, y, E, R, b, r, X, x, L, k, v, f, F, U, z) {
    M = M | 0, N = N | 0, y = y | 0, E = E | 0, R = R | 0, b = b | 0, r = r | 0, X = X | 0, x = x | 0, L = L | 0, k = k | 0, v = v | 0, f = f | 0, F = F | 0, U = U | 0, z = z | 0;
    var s = 0, i = 0, l = 0, o = 0, c = 0, d = 0, P = 0, S = 0;
    s = n, i = a, l = h, o = D, c = g, d = C, P = u, S = $, S = M + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 1116352408 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, P = N + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 1899447441 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, d = y + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 3049323471 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, c = E + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 3921009573 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, o = R + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 961987163 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, l = b + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 1508970993 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, i = r + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 2453635748 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, s = X + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 2870763221 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, S = x + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 3624381080 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, P = L + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 310598401 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, d = k + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 607225278 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, c = v + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 1426881987 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, o = f + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 1925078388 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, l = F + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 2162078206 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, i = U + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 2614888103 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, s = z + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 3248222580 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, M = (N >>> 7 ^ N >>> 18 ^ N >>> 3 ^ N << 25 ^ N << 14) + (U >>> 17 ^ U >>> 19 ^ U >>> 10 ^ U << 15 ^ U << 13) + M + L | 0, S = M + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 3835390401 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, N = (y >>> 7 ^ y >>> 18 ^ y >>> 3 ^ y << 25 ^ y << 14) + (z >>> 17 ^ z >>> 19 ^ z >>> 10 ^ z << 15 ^ z << 13) + N + k | 0, P = N + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 4022224774 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, y = (E >>> 7 ^ E >>> 18 ^ E >>> 3 ^ E << 25 ^ E << 14) + (M >>> 17 ^ M >>> 19 ^ M >>> 10 ^ M << 15 ^ M << 13) + y + v | 0, d = y + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 264347078 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, E = (R >>> 7 ^ R >>> 18 ^ R >>> 3 ^ R << 25 ^ R << 14) + (N >>> 17 ^ N >>> 19 ^ N >>> 10 ^ N << 15 ^ N << 13) + E + f | 0, c = E + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 604807628 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, R = (b >>> 7 ^ b >>> 18 ^ b >>> 3 ^ b << 25 ^ b << 14) + (y >>> 17 ^ y >>> 19 ^ y >>> 10 ^ y << 15 ^ y << 13) + R + F | 0, o = R + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 770255983 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, b = (r >>> 7 ^ r >>> 18 ^ r >>> 3 ^ r << 25 ^ r << 14) + (E >>> 17 ^ E >>> 19 ^ E >>> 10 ^ E << 15 ^ E << 13) + b + U | 0, l = b + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 1249150122 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, r = (X >>> 7 ^ X >>> 18 ^ X >>> 3 ^ X << 25 ^ X << 14) + (R >>> 17 ^ R >>> 19 ^ R >>> 10 ^ R << 15 ^ R << 13) + r + z | 0, i = r + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 1555081692 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, X = (x >>> 7 ^ x >>> 18 ^ x >>> 3 ^ x << 25 ^ x << 14) + (b >>> 17 ^ b >>> 19 ^ b >>> 10 ^ b << 15 ^ b << 13) + X + M | 0, s = X + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 1996064986 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, x = (L >>> 7 ^ L >>> 18 ^ L >>> 3 ^ L << 25 ^ L << 14) + (r >>> 17 ^ r >>> 19 ^ r >>> 10 ^ r << 15 ^ r << 13) + x + N | 0, S = x + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 2554220882 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, L = (k >>> 7 ^ k >>> 18 ^ k >>> 3 ^ k << 25 ^ k << 14) + (X >>> 17 ^ X >>> 19 ^ X >>> 10 ^ X << 15 ^ X << 13) + L + y | 0, P = L + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 2821834349 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, k = (v >>> 7 ^ v >>> 18 ^ v >>> 3 ^ v << 25 ^ v << 14) + (x >>> 17 ^ x >>> 19 ^ x >>> 10 ^ x << 15 ^ x << 13) + k + E | 0, d = k + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 2952996808 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, v = (f >>> 7 ^ f >>> 18 ^ f >>> 3 ^ f << 25 ^ f << 14) + (L >>> 17 ^ L >>> 19 ^ L >>> 10 ^ L << 15 ^ L << 13) + v + R | 0, c = v + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 3210313671 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, f = (F >>> 7 ^ F >>> 18 ^ F >>> 3 ^ F << 25 ^ F << 14) + (k >>> 17 ^ k >>> 19 ^ k >>> 10 ^ k << 15 ^ k << 13) + f + b | 0, o = f + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 3336571891 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, F = (U >>> 7 ^ U >>> 18 ^ U >>> 3 ^ U << 25 ^ U << 14) + (v >>> 17 ^ v >>> 19 ^ v >>> 10 ^ v << 15 ^ v << 13) + F + r | 0, l = F + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 3584528711 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, U = (z >>> 7 ^ z >>> 18 ^ z >>> 3 ^ z << 25 ^ z << 14) + (f >>> 17 ^ f >>> 19 ^ f >>> 10 ^ f << 15 ^ f << 13) + U + X | 0, i = U + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 113926993 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, z = (M >>> 7 ^ M >>> 18 ^ M >>> 3 ^ M << 25 ^ M << 14) + (F >>> 17 ^ F >>> 19 ^ F >>> 10 ^ F << 15 ^ F << 13) + z + x | 0, s = z + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 338241895 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, M = (N >>> 7 ^ N >>> 18 ^ N >>> 3 ^ N << 25 ^ N << 14) + (U >>> 17 ^ U >>> 19 ^ U >>> 10 ^ U << 15 ^ U << 13) + M + L | 0, S = M + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 666307205 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, N = (y >>> 7 ^ y >>> 18 ^ y >>> 3 ^ y << 25 ^ y << 14) + (z >>> 17 ^ z >>> 19 ^ z >>> 10 ^ z << 15 ^ z << 13) + N + k | 0, P = N + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 773529912 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, y = (E >>> 7 ^ E >>> 18 ^ E >>> 3 ^ E << 25 ^ E << 14) + (M >>> 17 ^ M >>> 19 ^ M >>> 10 ^ M << 15 ^ M << 13) + y + v | 0, d = y + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 1294757372 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, E = (R >>> 7 ^ R >>> 18 ^ R >>> 3 ^ R << 25 ^ R << 14) + (N >>> 17 ^ N >>> 19 ^ N >>> 10 ^ N << 15 ^ N << 13) + E + f | 0, c = E + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 1396182291 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, R = (b >>> 7 ^ b >>> 18 ^ b >>> 3 ^ b << 25 ^ b << 14) + (y >>> 17 ^ y >>> 19 ^ y >>> 10 ^ y << 15 ^ y << 13) + R + F | 0, o = R + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 1695183700 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, b = (r >>> 7 ^ r >>> 18 ^ r >>> 3 ^ r << 25 ^ r << 14) + (E >>> 17 ^ E >>> 19 ^ E >>> 10 ^ E << 15 ^ E << 13) + b + U | 0, l = b + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 1986661051 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, r = (X >>> 7 ^ X >>> 18 ^ X >>> 3 ^ X << 25 ^ X << 14) + (R >>> 17 ^ R >>> 19 ^ R >>> 10 ^ R << 15 ^ R << 13) + r + z | 0, i = r + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 2177026350 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, X = (x >>> 7 ^ x >>> 18 ^ x >>> 3 ^ x << 25 ^ x << 14) + (b >>> 17 ^ b >>> 19 ^ b >>> 10 ^ b << 15 ^ b << 13) + X + M | 0, s = X + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 2456956037 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, x = (L >>> 7 ^ L >>> 18 ^ L >>> 3 ^ L << 25 ^ L << 14) + (r >>> 17 ^ r >>> 19 ^ r >>> 10 ^ r << 15 ^ r << 13) + x + N | 0, S = x + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 2730485921 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, L = (k >>> 7 ^ k >>> 18 ^ k >>> 3 ^ k << 25 ^ k << 14) + (X >>> 17 ^ X >>> 19 ^ X >>> 10 ^ X << 15 ^ X << 13) + L + y | 0, P = L + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 2820302411 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, k = (v >>> 7 ^ v >>> 18 ^ v >>> 3 ^ v << 25 ^ v << 14) + (x >>> 17 ^ x >>> 19 ^ x >>> 10 ^ x << 15 ^ x << 13) + k + E | 0, d = k + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 3259730800 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, v = (f >>> 7 ^ f >>> 18 ^ f >>> 3 ^ f << 25 ^ f << 14) + (L >>> 17 ^ L >>> 19 ^ L >>> 10 ^ L << 15 ^ L << 13) + v + R | 0, c = v + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 3345764771 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, f = (F >>> 7 ^ F >>> 18 ^ F >>> 3 ^ F << 25 ^ F << 14) + (k >>> 17 ^ k >>> 19 ^ k >>> 10 ^ k << 15 ^ k << 13) + f + b | 0, o = f + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 3516065817 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, F = (U >>> 7 ^ U >>> 18 ^ U >>> 3 ^ U << 25 ^ U << 14) + (v >>> 17 ^ v >>> 19 ^ v >>> 10 ^ v << 15 ^ v << 13) + F + r | 0, l = F + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 3600352804 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, U = (z >>> 7 ^ z >>> 18 ^ z >>> 3 ^ z << 25 ^ z << 14) + (f >>> 17 ^ f >>> 19 ^ f >>> 10 ^ f << 15 ^ f << 13) + U + X | 0, i = U + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 4094571909 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, z = (M >>> 7 ^ M >>> 18 ^ M >>> 3 ^ M << 25 ^ M << 14) + (F >>> 17 ^ F >>> 19 ^ F >>> 10 ^ F << 15 ^ F << 13) + z + x | 0, s = z + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 275423344 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, M = (N >>> 7 ^ N >>> 18 ^ N >>> 3 ^ N << 25 ^ N << 14) + (U >>> 17 ^ U >>> 19 ^ U >>> 10 ^ U << 15 ^ U << 13) + M + L | 0, S = M + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 430227734 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, N = (y >>> 7 ^ y >>> 18 ^ y >>> 3 ^ y << 25 ^ y << 14) + (z >>> 17 ^ z >>> 19 ^ z >>> 10 ^ z << 15 ^ z << 13) + N + k | 0, P = N + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 506948616 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, y = (E >>> 7 ^ E >>> 18 ^ E >>> 3 ^ E << 25 ^ E << 14) + (M >>> 17 ^ M >>> 19 ^ M >>> 10 ^ M << 15 ^ M << 13) + y + v | 0, d = y + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 659060556 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, E = (R >>> 7 ^ R >>> 18 ^ R >>> 3 ^ R << 25 ^ R << 14) + (N >>> 17 ^ N >>> 19 ^ N >>> 10 ^ N << 15 ^ N << 13) + E + f | 0, c = E + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 883997877 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, R = (b >>> 7 ^ b >>> 18 ^ b >>> 3 ^ b << 25 ^ b << 14) + (y >>> 17 ^ y >>> 19 ^ y >>> 10 ^ y << 15 ^ y << 13) + R + F | 0, o = R + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 958139571 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, b = (r >>> 7 ^ r >>> 18 ^ r >>> 3 ^ r << 25 ^ r << 14) + (E >>> 17 ^ E >>> 19 ^ E >>> 10 ^ E << 15 ^ E << 13) + b + U | 0, l = b + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 1322822218 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, r = (X >>> 7 ^ X >>> 18 ^ X >>> 3 ^ X << 25 ^ X << 14) + (R >>> 17 ^ R >>> 19 ^ R >>> 10 ^ R << 15 ^ R << 13) + r + z | 0, i = r + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 1537002063 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, X = (x >>> 7 ^ x >>> 18 ^ x >>> 3 ^ x << 25 ^ x << 14) + (b >>> 17 ^ b >>> 19 ^ b >>> 10 ^ b << 15 ^ b << 13) + X + M | 0, s = X + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 1747873779 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, x = (L >>> 7 ^ L >>> 18 ^ L >>> 3 ^ L << 25 ^ L << 14) + (r >>> 17 ^ r >>> 19 ^ r >>> 10 ^ r << 15 ^ r << 13) + x + N | 0, S = x + S + (c >>> 6 ^ c >>> 11 ^ c >>> 25 ^ c << 26 ^ c << 21 ^ c << 7) + (P ^ c & (d ^ P)) + 1955562222 | 0, o = o + S | 0, S = S + (s & i ^ l & (s ^ i)) + (s >>> 2 ^ s >>> 13 ^ s >>> 22 ^ s << 30 ^ s << 19 ^ s << 10) | 0, L = (k >>> 7 ^ k >>> 18 ^ k >>> 3 ^ k << 25 ^ k << 14) + (X >>> 17 ^ X >>> 19 ^ X >>> 10 ^ X << 15 ^ X << 13) + L + y | 0, P = L + P + (o >>> 6 ^ o >>> 11 ^ o >>> 25 ^ o << 26 ^ o << 21 ^ o << 7) + (d ^ o & (c ^ d)) + 2024104815 | 0, l = l + P | 0, P = P + (S & s ^ i & (S ^ s)) + (S >>> 2 ^ S >>> 13 ^ S >>> 22 ^ S << 30 ^ S << 19 ^ S << 10) | 0, k = (v >>> 7 ^ v >>> 18 ^ v >>> 3 ^ v << 25 ^ v << 14) + (x >>> 17 ^ x >>> 19 ^ x >>> 10 ^ x << 15 ^ x << 13) + k + E | 0, d = k + d + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (c ^ l & (o ^ c)) + 2227730452 | 0, i = i + d | 0, d = d + (P & S ^ s & (P ^ S)) + (P >>> 2 ^ P >>> 13 ^ P >>> 22 ^ P << 30 ^ P << 19 ^ P << 10) | 0, v = (f >>> 7 ^ f >>> 18 ^ f >>> 3 ^ f << 25 ^ f << 14) + (L >>> 17 ^ L >>> 19 ^ L >>> 10 ^ L << 15 ^ L << 13) + v + R | 0, c = v + c + (i >>> 6 ^ i >>> 11 ^ i >>> 25 ^ i << 26 ^ i << 21 ^ i << 7) + (o ^ i & (l ^ o)) + 2361852424 | 0, s = s + c | 0, c = c + (d & P ^ S & (d ^ P)) + (d >>> 2 ^ d >>> 13 ^ d >>> 22 ^ d << 30 ^ d << 19 ^ d << 10) | 0, f = (F >>> 7 ^ F >>> 18 ^ F >>> 3 ^ F << 25 ^ F << 14) + (k >>> 17 ^ k >>> 19 ^ k >>> 10 ^ k << 15 ^ k << 13) + f + b | 0, o = f + o + (s >>> 6 ^ s >>> 11 ^ s >>> 25 ^ s << 26 ^ s << 21 ^ s << 7) + (l ^ s & (i ^ l)) + 2428436474 | 0, S = S + o | 0, o = o + (c & d ^ P & (c ^ d)) + (c >>> 2 ^ c >>> 13 ^ c >>> 22 ^ c << 30 ^ c << 19 ^ c << 10) | 0, F = (U >>> 7 ^ U >>> 18 ^ U >>> 3 ^ U << 25 ^ U << 14) + (v >>> 17 ^ v >>> 19 ^ v >>> 10 ^ v << 15 ^ v << 13) + F + r | 0, l = F + l + (S >>> 6 ^ S >>> 11 ^ S >>> 25 ^ S << 26 ^ S << 21 ^ S << 7) + (i ^ S & (s ^ i)) + 2756734187 | 0, P = P + l | 0, l = l + (o & c ^ d & (o ^ c)) + (o >>> 2 ^ o >>> 13 ^ o >>> 22 ^ o << 30 ^ o << 19 ^ o << 10) | 0, U = (z >>> 7 ^ z >>> 18 ^ z >>> 3 ^ z << 25 ^ z << 14) + (f >>> 17 ^ f >>> 19 ^ f >>> 10 ^ f << 15 ^ f << 13) + U + X | 0, i = U + i + (P >>> 6 ^ P >>> 11 ^ P >>> 25 ^ P << 26 ^ P << 21 ^ P << 7) + (s ^ P & (S ^ s)) + 3204031479 | 0, d = d + i | 0, i = i + (l & o ^ c & (l ^ o)) + (l >>> 2 ^ l >>> 13 ^ l >>> 22 ^ l << 30 ^ l << 19 ^ l << 10) | 0, z = (M >>> 7 ^ M >>> 18 ^ M >>> 3 ^ M << 25 ^ M << 14) + (F >>> 17 ^ F >>> 19 ^ F >>> 10 ^ F << 15 ^ F << 13) + z + x | 0, s = z + s + (d >>> 6 ^ d >>> 11 ^ d >>> 25 ^ d << 26 ^ d << 21 ^ d << 7) + (S ^ d & (P ^ S)) + 3329325298 | 0, c = c + s | 0, s = s + (i & l ^ o & (i ^ l)) + (i >>> 2 ^ i >>> 13 ^ i >>> 22 ^ i << 30 ^ i << 19 ^ i << 10) | 0, n = n + s | 0, a = a + i | 0, h = h + l | 0, D = D + o | 0, g = g + c | 0, C = C + d | 0, u = u + P | 0, $ = $ + S | 0;
  }
  function Pe(M) {
    M = M | 0, B(
      I[M | 0] << 24 | I[M | 1] << 16 | I[M | 2] << 8 | I[M | 3],
      I[M | 4] << 24 | I[M | 5] << 16 | I[M | 6] << 8 | I[M | 7],
      I[M | 8] << 24 | I[M | 9] << 16 | I[M | 10] << 8 | I[M | 11],
      I[M | 12] << 24 | I[M | 13] << 16 | I[M | 14] << 8 | I[M | 15],
      I[M | 16] << 24 | I[M | 17] << 16 | I[M | 18] << 8 | I[M | 19],
      I[M | 20] << 24 | I[M | 21] << 16 | I[M | 22] << 8 | I[M | 23],
      I[M | 24] << 24 | I[M | 25] << 16 | I[M | 26] << 8 | I[M | 27],
      I[M | 28] << 24 | I[M | 29] << 16 | I[M | 30] << 8 | I[M | 31],
      I[M | 32] << 24 | I[M | 33] << 16 | I[M | 34] << 8 | I[M | 35],
      I[M | 36] << 24 | I[M | 37] << 16 | I[M | 38] << 8 | I[M | 39],
      I[M | 40] << 24 | I[M | 41] << 16 | I[M | 42] << 8 | I[M | 43],
      I[M | 44] << 24 | I[M | 45] << 16 | I[M | 46] << 8 | I[M | 47],
      I[M | 48] << 24 | I[M | 49] << 16 | I[M | 50] << 8 | I[M | 51],
      I[M | 52] << 24 | I[M | 53] << 16 | I[M | 54] << 8 | I[M | 55],
      I[M | 56] << 24 | I[M | 57] << 16 | I[M | 58] << 8 | I[M | 59],
      I[M | 60] << 24 | I[M | 61] << 16 | I[M | 62] << 8 | I[M | 63]
    );
  }
  function St(M) {
    M = M | 0, I[M | 0] = n >>> 24, I[M | 1] = n >>> 16 & 255, I[M | 2] = n >>> 8 & 255, I[M | 3] = n & 255, I[M | 4] = a >>> 24, I[M | 5] = a >>> 16 & 255, I[M | 6] = a >>> 8 & 255, I[M | 7] = a & 255, I[M | 8] = h >>> 24, I[M | 9] = h >>> 16 & 255, I[M | 10] = h >>> 8 & 255, I[M | 11] = h & 255, I[M | 12] = D >>> 24, I[M | 13] = D >>> 16 & 255, I[M | 14] = D >>> 8 & 255, I[M | 15] = D & 255, I[M | 16] = g >>> 24, I[M | 17] = g >>> 16 & 255, I[M | 18] = g >>> 8 & 255, I[M | 19] = g & 255, I[M | 20] = C >>> 24, I[M | 21] = C >>> 16 & 255, I[M | 22] = C >>> 8 & 255, I[M | 23] = C & 255, I[M | 24] = u >>> 24, I[M | 25] = u >>> 16 & 255, I[M | 26] = u >>> 8 & 255, I[M | 27] = u & 255, I[M | 28] = $ >>> 24, I[M | 29] = $ >>> 16 & 255, I[M | 30] = $ >>> 8 & 255, I[M | 31] = $ & 255;
  }
  function ht() {
    n = 1779033703, a = 3144134277, h = 1013904242, D = 2773480762, g = 1359893119, C = 2600822924, u = 528734635, $ = 1541459225, K = _ = 0;
  }
  function Tt(M, N, y, E, R, b, r, X, x, L) {
    M = M | 0, N = N | 0, y = y | 0, E = E | 0, R = R | 0, b = b | 0, r = r | 0, X = X | 0, x = x | 0, L = L | 0, n = M, a = N, h = y, D = E, g = R, C = b, u = r, $ = X, K = x, _ = L;
  }
  function xe(M, N) {
    M = M | 0, N = N | 0;
    var y = 0;
    if (M & 63)
      return -1;
    for (; (N | 0) >= 64; )
      Pe(M), M = M + 64 | 0, N = N - 64 | 0, y = y + 64 | 0;
    return K = K + y | 0, K >>> 0 < y >>> 0 && (_ = _ + 1 | 0), y | 0;
  }
  function Mt(M, N, y) {
    M = M | 0, N = N | 0, y = y | 0;
    var E = 0, R = 0;
    if (M & 63 || ~y && y & 31)
      return -1;
    if ((N | 0) >= 64) {
      if (E = xe(M, N) | 0, (E | 0) == -1)
        return -1;
      M = M + E | 0, N = N - E | 0;
    }
    if (E = E + N | 0, K = K + N | 0, K >>> 0 < N >>> 0 && (_ = _ + 1 | 0), I[M | N] = 128, (N | 0) >= 56) {
      for (R = N + 1 | 0; (R | 0) < 64; R = R + 1 | 0)
        I[M | R] = 0;
      Pe(M), N = 0, I[M | 0] = 0;
    }
    for (R = N + 1 | 0; (R | 0) < 59; R = R + 1 | 0)
      I[M | R] = 0;
    return I[M | 56] = _ >>> 21 & 255, I[M | 57] = _ >>> 13 & 255, I[M | 58] = _ >>> 5 & 255, I[M | 59] = _ << 3 & 255 | K >>> 29, I[M | 60] = K >>> 21 & 255, I[M | 61] = K >>> 13 & 255, I[M | 62] = K >>> 5 & 255, I[M | 63] = K << 3 & 255, Pe(M), ~y && St(y), E | 0;
  }
  return {
    init: Tt,
    reset: ht,
    process: xe,
    finish: Mt
  };
};
const gl = 32, Nl = 64, Ue = [], ze = [];
class Cl {
  constructor() {
    O(this, "result");
    O(this, "pos", 0);
    O(this, "len", 0);
    O(this, "asm");
    O(this, "heap");
    O(this, "BLOCK_SIZE");
    O(this, "HASH_SIZE");
  }
  reset() {
    const { asm: t } = this.acquire_asm();
    return this.result = null, this.pos = 0, this.len = 0, t.reset(), this;
  }
  process(t) {
    if (this.result !== null)
      throw new $e(
        "state must be reset before processing new data"
      );
    const { asm: n, heap: a } = this.acquire_asm();
    let h = this.pos, D = this.len, g = 0, C = t.length, u = 0;
    for (; C > 0; )
      u = dl(a, h + D, t, g, C), D += u, g += u, C -= u, u = n.process(h, D), h += u, D -= u, D || (h = 0);
    return this.pos = h, this.len = D, this;
  }
  finish() {
    if (this.result !== null)
      throw new $e("finish can only be called once");
    const { asm: t, heap: n } = this.acquire_asm();
    return t.finish(this.pos, this.len, 0), this.result = new Uint8Array(this.HASH_SIZE), this.result.set(n.subarray(0, this.HASH_SIZE)), this.pos = 0, this.len = 0, this.release_asm(), this;
  }
}
const Me = class Me extends Cl {
  constructor() {
    super();
    O(this, "NAME", "sha256");
    O(this, "HASH_SIZE", gl);
    O(this, "BLOCK_SIZE", Nl);
    this.acquire_asm();
  }
  acquire_asm() {
    return (this.heap === void 0 || this.asm === void 0) && (this.heap = Ue.pop() || cl(), this.asm = ze.pop() || jl({ Uint8Array }, this.heap.buffer), this.reset()), { heap: this.heap, asm: this.asm };
  }
  release_asm() {
    this.heap !== void 0 && this.asm !== void 0 && (Ue.push(this.heap), ze.push(this.asm)), this.heap = void 0, this.asm = void 0;
  }
  static bytes(n) {
    return new Me().process(n).finish().result;
  }
};
O(Me, "NAME", "sha256");
let Ee = Me;
class $e extends Error {
  constructor(t) {
    super(t), this.name = "IllegalStateError";
  }
}
function yl(e, t, n) {
  ol(
    e,
    (a) => {
      try {
        crypto.subtle.digest("SHA-256", a).then((h) => {
          t(fe(new Uint8Array(h)));
        });
      } catch {
        const D = Ee.bytes(new Uint8Array(a));
        if (!D)
          return n(new DOMException("Failed to hash blob"));
        t(fe(D));
      }
    },
    n
  );
}
class Rl {
  constructor(t, n) {
    O(this, "opts");
    O(this, "session");
    O(this, "request");
    O(this, "attempts");
    O(this, "aborted");
    this.session = t, this.attempts = 0, this.opts = n, this.request = new XMLHttpRequest(), this.aborted = !1, this.init();
  }
  abort() {
    this.request.abort(), this.aborted = !0;
  }
  /**
   * Attempts to hash and upload the file chunk
   */
  async init() {
    const { file: t, info: n, unit: a } = this.opts, { order: h, size: D, maxSize: g } = a, C = g * h, u = Math.min(C + D, n.size), $ = t.slice(C, u);
    return yl($, (K) => this.transfer($, K), this.fail), !1;
  }
  /**
   * Uploads the file chunk to the server
   * @param chunk The chunk of the file
   * @param hash The hash of the chunk
   */
  async transfer(t, n) {
    if (this.aborted)
      return;
    const { unit: a, info: h } = this.opts, { order: D, size: g } = a, { uuid: C } = h;
    try {
      const u = await ct({
        id: this.session,
        name: C,
        hash: n,
        size: g,
        chunk: t,
        order: D + 1,
        hash_algo: "sha256",
        customXHR: this.request,
        onProgress: dt(this.progress.bind(this), 200, {
          leading: !0,
          trailing: !1
        })
      });
      u.result ? this.opts.done(this) : this.fail(u.error ?? new DOMException("Failed to upload chunk"));
    } catch {
      this.fail(new DOMException("Failed to upload chunk"));
    }
  }
  progress(t) {
    !t.lengthComputable || !t.loaded || this.aborted || this.opts.push(t, this);
  }
  async fail(t) {
    if (!this.aborted) {
      if (this.opts.retries - this.attempts > 0) {
        await il((this.opts.retries - this.attempts) * 1e3), this.attempts++, this.init();
        return;
      }
      this.opts.fail(t, this);
    }
  }
}
class El {
  constructor(t, n, a, h, D) {
    O(this, "file");
    O(this, "info");
    O(this, "opts");
    O(this, "events");
    O(this, "chunks", []);
    O(this, "uploaded", []);
    O(this, "chunkCount");
    O(this, "session");
    O(this, "threads");
    O(this, "paused", !1);
    O(this, "failed", !1);
    O(this, "aborted", !1);
    this.file = t, this.info = n, this.opts = a, this.events = h, this.session = D, this.threads = 0, this.chunkCount = Math.ceil(this.info.size / this.getChunkSize()), this.init();
  }
  pause() {
    var t, n;
    this.paused = !0, (n = (t = this.events).paused) == null || n.call(t, {
      uuid: this.info.uuid,
      status: G.Paused
    });
  }
  resume() {
    var t, n;
    this.paused = !1, this.transfer(), (n = (t = this.events).resumed) == null || n.call(t, {
      uuid: this.info.uuid,
      status: G.Uploading
    });
  }
  retry() {
    this.reset(), this.init();
  }
  cancel() {
    var t, n;
    this.aborted = !0, this.chunks.forEach((a) => a == null ? void 0 : a.abort()), this.chunks = [], (n = (t = this.events).aborted) == null || n.call(t, {
      status: G.Aborted,
      uuid: this.info.uuid
    });
  }
  reset() {
    this.chunks = [], this.uploaded = [], this.threads = 0, this.session = void 0, this.paused = !1, this.failed = !1, this.aborted = !1;
  }
  async init() {
    var t, n;
    if (!(this.failed || this.aborted)) {
      if (!this.session) {
        const a = await lt({
          org: this.opts.orgName,
          name: this.info.name,
          size: this.info.size,
          hash: this.info.hash,
          hash_algo: "sha256",
          action: "create",
          folder_id: this.opts.folderId,
          instance_id: this.opts.instanceId,
          relative_path: this.opts.relativePath
        });
        if (!a || !a.result)
          return this.fail(
            a.error || new DOMException("Session create failed")
          );
        if (this.aborted) {
          await re({ id: a.id });
          return;
        }
        this.session = a.id, (n = (t = this.events).created) == null || n.call(t, {
          status: G.Ready,
          uuid: this.info.uuid,
          sessionId: this.session
        });
      }
      this.aborted || this.transfer();
    }
  }
  transfer() {
    if (this.failed)
      return;
    const t = this.opts.threads - this.threads, n = Math.min(this.chunkCount, t);
    if (n <= 0)
      return;
    this.getNextChunks(n).forEach((h) => {
      if (!this.session) {
        this.fail(new DOMException("Upload session not found"));
        return;
      }
      const D = this.getChunkSize(h), g = this.getChunkSize();
      this.threads++, this.chunks[h] = new Rl(this.session, {
        ...this.opts,
        file: this.file,
        info: this.info,
        unit: { order: h, size: D, maxSize: g },
        push: (C, u) => this.progress(C, u),
        fail: (C, u) => this.fail(C, u),
        done: (C) => this.next(C)
      });
    });
  }
  next(t) {
    if (this.failed || this.aborted)
      return;
    const n = t.opts.unit.order;
    if (this.uploaded[n] = this.getChunkSize(n), this.chunks[n] = null, this.threads--, this.getByteProgress() === this.info.size) {
      this.complete();
      return;
    }
    this.paused || this.transfer();
  }
  async complete() {
    var t, n;
    if (!(this.failed || this.aborted)) {
      if (!this.session)
        return this.fail(new DOMException("Upload session not found"));
      (n = (t = this.events).completed) == null || n.call(t, {
        status: G.Ready,
        uuid: this.info.uuid
      });
    }
  }
  progress(t, n) {
    var h, D;
    if (this.failed || this.aborted)
      return;
    const a = n.opts.unit.order;
    if (this.uploaded[a] = Math.min(t.loaded, this.getChunkSize(a)), t.type === "progress") {
      if (this.paused)
        return;
      (D = (h = this.events).progressed) == null || D.call(h, {
        status: G.Uploading,
        uuid: this.info.uuid,
        total: this.info.size,
        bytes: this.getByteProgress()
      });
      return;
    }
    if (t.type === "error" || t.type === "timeout")
      return this.fail(t, n);
  }
  fail(t, n) {
    var a, h;
    if (!(this.failed || this.aborted)) {
      if (this.failed = !0, this.chunks.forEach((D) => D == null ? void 0 : D.abort()), n) {
        const D = n.opts.unit.order;
        this.uploaded[D] = 0, delete this.chunks[D], this.threads--;
      }
      (h = (a = this.events).failed) == null || h.call(a, {
        uuid: this.info.uuid,
        status: G.Failed,
        error: t
      });
    }
  }
  getNextChunks(t) {
    const n = [];
    for (let a = 0; a < this.chunkCount && (this.uploaded[a] || n.push(a), n.length !== t); a++)
      ;
    return n;
  }
  getByteProgress() {
    return this.uploaded.reduce((t, n) => t + n, 0);
  }
  getChunkSize(t) {
    const [n, a] = this.opts.chunkSizes;
    return t && t === this.chunkCount - 1 ? this.info.size % a || a : Math.min(a, this.info.size);
  }
}
const ne = {
  uploadItems: [],
  hashItems: [],
  active: /* @__PURE__ */ new Set(),
  uploads: /* @__PURE__ */ new Map(),
  hashers: /* @__PURE__ */ new Map(),
  maxPerSecond: Il,
  maxConcurrent: ml,
  lastQueue: 0,
  timer: null,
  start() {
    (() => {
      (this.uploadItems.length || this.hashItems.length || this.active.size) && (this.processUploads(), this.processHashes());
    })();
  },
  stop() {
    this.timer !== null && (clearTimeout(this.timer), this.timer = null);
  },
  processUploads() {
    if (this.active.size >= this.maxConcurrent) {
      console.log(">> skipped upload (max concurrent)");
      return;
    }
    const e = this.uploadItems.shift();
    if (!e)
      return;
    console.log(">> uploading", e[0][0].name);
    const [t, n, a] = e, [h, D, g, C, u, $, K] = t;
    this.active.add(D.uuid), this.uploads.set(
      D.uuid,
      new El(h, D, g, {
        created: (_) => C == null ? void 0 : C(_),
        progressed: (_) => u == null ? void 0 : u(_),
        completed: (_) => {
          this.active.delete(D.uuid), this.uploads.delete(D.uuid), this.processUploads(), n(_);
        },
        aborted: (_) => {
          this.active.delete(D.uuid), this.uploads.delete(D.uuid), this.processUploads(), a(_);
        },
        failed: (_) => {
          this.active.delete(D.uuid), this.uploads.delete(D.uuid), this.processUploads(), a(_);
        },
        paused: (_) => {
          this.active.delete(D.uuid), this.processUploads(), $ == null || $(_);
        },
        resumed: (_) => {
          this.uploadItems.unshift([
            [h, D, g, C, u, $, K],
            n,
            a
          ]), this.processUploads(), K == null || K(_);
        }
      })
    );
  },
  processHashes() {
    if (this.active.size >= this.maxConcurrent)
      return;
    const e = this.hashItems.shift();
    if (!e)
      return;
    const [t, n, a] = e, [h, D, g, C] = t;
    this.active.add(D);
    const u = new ul();
    this.hashers.set(D, u), u.onerror = ($) => {
      this.active.delete(D), this.hashers.delete(D), u.terminate(), this.processHashes(), a($);
    }, u.onmessage = ($) => {
      switch ($.data.id) {
        case "hash::res::progressed":
          return C == null ? void 0 : C($.data.op);
        case "hash::res::completed":
          return this.active.delete(D), this.hashers.delete(D), u.terminate(), this.processHashes(), n($.data.op);
        case "hash::res::failed":
          return this.active.delete(D), this.hashers.delete(D), u.terminate(), this.processHashes(), a($.data.op);
        default:
          $.data;
      }
    }, u.postMessage({
      id: "hash::req::start",
      op: [h, D, g]
    });
  },
  addUpload(...e) {
    return new Promise((t, n) => {
      this.uploadItems.push([e, t, n]), this.timer ? this.processUploads() : this.start();
    });
  },
  addHash(...e) {
    return new Promise((t, n) => {
      this.hashItems.push([e, t, n]), this.timer ? this.processHashes() : this.start();
    });
  },
  cancelUpload(e) {
    const t = this.uploads.get(e);
    t && (t.cancel(), this.uploads.delete(e));
  },
  cancelHash(e) {
    const t = this.hashers.get(e);
    t && (t.terminate(), this.hashers.delete(e));
  }
};
class Ol {
  async pickFiles(t = !0, n = "") {
    return new Promise((a) => {
      const h = document.createElement("input");
      h.type = "file", h.multiple = t, h.accept = n ?? void 0, h.onchange = () => a(h.files), h.click();
    });
  }
  async hashFile(...t) {
    return ne.addHash(...t);
  }
  async uploadFile(...t) {
    return ne.addUpload(...t);
  }
  async retryUpload(...t) {
    var a;
    const [n] = t;
    (a = ne.uploads.get(n)) == null || a.retry();
  }
  async pauseUpload(...t) {
    var a;
    const [n] = t;
    (a = ne.uploads.get(n)) == null || a.pause();
  }
  async resumeUpload(...t) {
    var a;
    const [n] = t;
    (a = ne.uploads.get(n)) == null || a.resume();
  }
  async cancelUpload(...t) {
    const [n] = t;
    ne.cancelUpload(n);
  }
  cancelHash(...t) {
    const [n] = t;
    ne.cancelHash(n);
  }
  start() {
    ne.start();
  }
  stop() {
    ne.stop();
  }
}
const ye = new Ol();
class _l {
  constructor(t, n) {
    O(this, "orgName");
    O(this, "memberId");
    O(this, "watchdogLast", /* @__PURE__ */ new Date());
    O(this, "watchdogThreshold", 5 * 1e3);
    O(this, "minChunkSize", Dl);
    O(this, "maxChunkSize", Ml);
    O(this, "maxFileSize", Tl);
    O(this, "maxThreads", hl);
    O(this, "maxRetries", Sl);
    O(this, "state", Ce({
      uploads: []
    }));
    O(this, "refresh", dt(this.process.bind(this), Pl, {
      leading: !0,
      trailing: !0
    }));
    this.orgName = t, this.memberId = n, this.process(), ye.start(), setInterval(this.watchdog.bind(this), 1e3);
  }
  /** Watches for stalled sessions */
  watchdog() {
    if (!this.state.uploads.some(
      (a) => a.status === G.Store || a.status === G.Storing || a.status === G.Assembling || a.status === G.Assemble
    ))
      return;
    (/* @__PURE__ */ new Date()).getTime() - this.watchdogLast.getTime() > this.watchdogThreshold && this.process();
  }
  /**
   * Processes all listed sessions
   */
  process() {
    this.watchdogLast = /* @__PURE__ */ new Date(), ot().then(({ sessions: t }) => {
      for (const n of t)
        n.status !== p.Ready && this.update(n);
    });
  }
  /**
   * Creates or updates a session's upload state
   */
  update(t) {
    const n = this.upsert(t), a = (h, D, g) => {
      D && (n.hashed = n.metadata.size), g && (n.bytes = n.metadata.size), h !== G.Ready && h !== G.Uploading && n.status !== G.Aborted && (n.status = h);
    };
    switch (t.status) {
      case p.Ready:
        return a(G.Ready, !0, !1);
      case p.Uploading:
        return a(G.Uploading, !0, !1);
      case p.Assemble:
        return a(G.Assemble, !0, !0);
      case p.Assembling:
        return a(G.Assembling, !0, !0);
      case p.Store:
        return a(G.Store, !0, !0);
      case p.Storing:
        return a(G.Storing, !0, !0);
      case p.Stored:
        return a(G.Stored, !0, !0);
      case p.Complete:
        return this.delete(t.id, !n.isOrigin), a(G.Complete, !0, !0);
      case p.AssemblyFailed:
        return n.error = t.status_message ?? void 0, this.delete(t.id, !n.isOrigin), a(G.AssemblyFailed, !0, !0);
      case p.StoreFailed:
        return n.error = t.status_message ?? void 0, this.attach(t), a(G.StoreFailed, !0, !0);
      default:
        t.status;
    }
  }
  /**
   * Creates or updates a session upload state
   */
  upsert(t) {
    var a, h, D;
    let n = this.state.uploads.find(
      (g) => g.sessionId === t.id
    );
    return n || (n = Ce({
      status: G.Queued,
      created: t.created,
      modified: t.updated,
      metadata: {
        uuid: ve(),
        size: t.size,
        name: t.filename,
        type: t.mime || "",
        hash: t.hash || ""
      },
      isOrigin: !1,
      wasReplaced: !1,
      memberId: this.memberId,
      sessionId: t.id,
      instanceId: ((a = t.target) == null ? void 0 : a.instance_id) || "",
      folderId: ((h = t.target) == null ? void 0 : h.folder_id) || "",
      relativePath: (D = t.target) == null ? void 0 : D.relative_path,
      fileId: t.new_file_id || null,
      hashed: t.size,
      bytes: t.status === p.Complete || t.status === p.Assemble || t.status === p.Assembling || t.status === p.Storing || t.status === p.Stored || t.status === p.StoreFailed ? t.size : 0
    }), this.state.uploads.push(n)), n;
  }
  /**
   * Deletes a session and optionally the local state
   */
  delete(t, n = !1, a = !0) {
    n && (this.state.uploads = this.state.uploads.filter(
      (h) => h.sessionId !== t
    )), a && t && re({ id: t });
  }
  /**
   * Attaches a session to the workspace or share folder
   */
  async attach(t) {
    const { id: n, target: a, filename: h } = t;
    if (a != null && a.folder_id)
      try {
        let D = null;
        if (a.instance_id.startsWith("4") ? D = "workspace" : a.instance_id.startsWith("5") && (D = "share"), !D)
          return;
        await it(D, a.instance_id).addFile(
          a.folder_id,
          h,
          JSON.stringify({
            type: "upload",
            upload: { id: n }
          })
        );
      } catch {
        this.delete(n, !0);
      }
  }
  /**
   * Adds a file to the upload queue
   */
  async addFile(t, n, a) {
    var _;
    const h = ve(), { type: D, size: g } = t, C = t.mfRelativePath, u = sl(t.name), $ = { uuid: h, name: u, type: D, size: g, hash: "" }, K = Ce({
      status: G.Queued,
      created: (/* @__PURE__ */ new Date()).toISOString(),
      modified: (/* @__PURE__ */ new Date()).toISOString(),
      metadata: $,
      isOrigin: !0,
      wasReplaced: !1,
      memberId: this.memberId,
      sessionId: null,
      instanceId: a,
      folderId: n,
      fileId: null,
      relativePath: C,
      hashed: 0,
      bytes: 0
    });
    this.state.uploads.push(K);
    try {
      K.metadata.hash = await ye.hashFile(
        t,
        h,
        this.maxChunkSize,
        (I) => {
          K.status = G.Hashing, K.hashed = I;
        }
      );
    } catch {
      K.status = G.HashFailed;
      return;
    }
    try {
      const I = await ye.uploadFile(
        t,
        $,
        {
          orgName: this.orgName,
          memberId: this.memberId,
          threads: this.maxThreads,
          retries: this.maxRetries,
          chunkSizes: [this.minChunkSize, this.maxChunkSize],
          relativePath: C,
          instanceId: a,
          folderId: n
        },
        // Created
        ({ sessionId: B }) => {
          K.sessionId = B;
        },
        // Progressed
        ({ status: B, bytes: Pe }) => {
          K.status = B, K.bytes = Pe;
        },
        // Paused
        () => {
          K.status = G.Paused;
        },
        // Resumed
        () => {
          K.status = G.Uploading;
        }
      );
      K.bytes = K.metadata.size, K.status = I.status;
    } catch (I) {
      const B = I;
      K.status = G.Failed, B.error instanceof ProgressEvent ? K.error = "Network error" : B.error instanceof DOMException ? K.error = B.error.message : K.error = ((_ = B.error) == null ? void 0 : _.text) ?? "Unknown error";
    }
  }
  /**
   * Adds a list of files to the upload queue
   */
  addFiles(t, n, a) {
    for (const h of t)
      this.addFile(h, n, a);
  }
  /**
   * Flags an upload as replaced by a storage node
   */
  flagReplaced(t) {
    const n = this.state.uploads.find((a) => a.sessionId === t);
    n && (n.wasReplaced = !0);
  }
}
export {
  Xl as Requests,
  ye as Transfers,
  G as UploadStatus,
  _l as Uploader,
  Ll as Utilities,
  xl as api,
  zt as callApi,
  kt as createFormData,
  vt as createQueryString,
  Ye as getBaseApiUrl,
  $t as getBaseOrigin,
  be as getBaseUrl,
  Ft as makeFetchRequest,
  Ut as makeXMLRequest,
  rl as websockets
};
//# sourceMappingURL=index.js.map
